/* eslint-disable */

//THIS COMPONENT RELIES ON NUMEROUS OTHERS WHICH OVERALL IS A BAD PRACTICE
//THIS MORE REPRESENTS A CONTAINER THAN A COMPONENT

import React, { Children, useState, useEffect, useRef } from "react";
import { useNavigate, useMatch, useLocation } from "react-router-dom";
// import { Switch, TouchableOpacity, Platform,Dimensions} from 'react-native'
import {
  Switch,
  Checkbox,
  Slider,
  Input,
  DatePicker,
  TimePicker,
  Modal,
  Radio,
  RadioChangeEvent,
  Cascader,
} from "antd";
// import { useDispatch, useSelector } from 'react-redux'
// import { getTool, getStatus, getRecipientShares } from '../../Stores/Tools/Selectors'
// import ToolActions from '../../Stores/Tools/Actions'
// import MessageActions from '../../Stores/Messages/Actions'
// import SessionActions from '../../Stores/Sessions/Actions'
// import CheckBox from '@react-native-community/checkbox'
import { View, Icon, Segment, Alert, Button } from "../../Components";
// import { TextInput } from 'react-native-gesture-handler'
// import Slider from '@react-native-community/slider'
// import DateTimePicker from '@react-native-community/datetimepicker'
// import ActionSheet from 'react-native-actionsheet'
import {
  updateSender,
  deleteShare as deleteShareAPI,
  updateMessage,
  updateAlert,
  addProjectImage,
} from "../../API";
import {
  ToolTypes,
  sensorLive,
  months,
  actionSheetStyle,
  Helpers,
  Metrics,
  Colors,
  Spacing,
  Fonts,
  size,
} from "../../global";
// import {
//   TextField,
//   FilledTextField,
//   OutlinedTextField,
// } from 'react-native-material-textfield';
// import { useFocusEffect } from '@react-navigation/native'
// import NavigationService from '../../Services/NavigationService'
import HelperService from "../../Helpers/HelperService";
import { ReactComponent as analogIcon } from "../../Assets/SVG/Analog_Big.svg";
import { ReactComponent as therm4Icon } from "../../Assets/SVG/4Ch_Big.svg";
import { ReactComponent as therm8Icon } from "../../Assets/SVG/8Ch_Big.svg";
import { ReactComponent as thpIcon } from "../../Assets/SVG/THP_Big.svg";
import { ReactComponent as aquaIcon } from "../../Assets/SVG/AquaSense_Big.svg";
import { ReactComponent as chemIcon } from "../../Assets/SVG/ChemSense_Big.svg";
import { ReactComponent as micIcon } from "../../Assets/SVG/Microphone_Big.svg";
import { ReactComponent as swimIcon } from "../../Assets/SVG/SwimSense_Big.svg";
import { ReactComponent as dropdownIcon } from "../../Assets/SVG/Dropdown.svg";
import { ReactComponent as disclosureIcon } from "../../Assets/SVG/next.svg";
import { ReactComponent as plusIcon } from "../../Assets/SVG/Add.svg";
import { ReactComponent as openIcon } from "../../Assets/SVG/down.svg";
import { ReactComponent as checkIcon } from "../../Assets/SVG/check.svg";
import { ReactComponent as arrowIcon } from "../../Assets/SVG/ArrowForwardSmallB.svg";
import { ReactComponent as wifiIcon } from "../../Assets/SVG/WiFi.svg";
import { ReactComponent as highIcon } from "../../Assets/SVG/High.svg";
import { ReactComponent as lowIcon } from "../../Assets/SVG/Low.svg";
import { ReactComponent as equalIcon } from "../../Assets/SVG/Equal.svg";
import { ReactComponent as closeIcon } from "../../Assets/SVG/Close.svg";
import { ReactComponent as prefIcon } from "../../Assets/SVG/Preferences.svg";
import { ReactComponent as alertIcon } from "../../Assets/SVG/Alert.svg";
import { ReactComponent as alertBigIcon } from "../../Assets/SVG/Alert_Big.svg";
import { ReactComponent as lessThanIcon } from "../../Assets/SVG/LessThan.svg";
import { ReactComponent as greaterThanIcon } from "../../Assets/SVG/GreaterThan.svg";
import { ReactComponent as powerLossIcon } from "../../Assets/SVG/PowerLoss.svg";
import { ReactComponent as networkLossIcon } from "../../Assets/SVG/NetworkLoss.svg";
import { ReactComponent as aIcon } from "../../Assets/SVG/A.svg";
import { ReactComponent as bIcon } from "../../Assets/SVG/B.svg";
import { ReactComponent as downloadIcon } from "../../Assets/SVG/Download.svg";
import { ReactComponent as sessionIcon } from "../../Assets/SVG/SessionIcon.svg";
import { ReactComponent as graphIcon } from "../../Assets/SVG/Graph.svg";
import { ReactComponent as hideIcon } from "../../Assets/SVG/HideW.svg";
import { ReactComponent as showIcon } from "../../Assets/SVG/ShowW.svg";
import { ReactComponent as syncIcon } from "../../Assets/SVG/Sync_Positive.svg";
import { ReactComponent as editIcon } from "../../Assets/SVG/EditIcon.svg";
import { ReactComponent as exportIcon } from "../../Assets/SVG/Export.svg";
import { ReactComponent as graphPropsIcon } from "../../Assets/SVG/GraphProperties.svg";
import { ReactComponent as optionsIcon } from "../../Assets/SVG/Options2.svg";
import { ReactComponent as fullscreenOffIcon } from "../../Assets/SVG/FullscreenOff.svg";
import { ReactComponent as fullscreenIcon } from "../../Assets/SVG/Fullscreen.svg";
import { ReactComponent as arrowRightIcon } from "../../Assets/SVG/ArrowRight.svg";
import { ReactComponent as finger1 } from "../../Assets/SVG/GraphFinger_1.svg";
import { ReactComponent as finger2 } from "../../Assets/SVG/GraphFinger_2.svg";
import { ReactComponent as folderIcon } from "../../Assets/SVG/Folder.svg";
import { ReactComponent as arrowUp } from "../../Assets/SVG/ArrowUpSmallG.svg";
import { ReactComponent as arrowDown } from "../../Assets/SVG/ArrowDownSmallG.svg";
import { ReactComponent as clockIcon } from "../../Assets/SVG/TimeAxis_Small.svg";
import { ReactComponent as zoomIcon } from "../../Assets/SVG/Zoom.svg";
import { ReactComponent as dot } from "../../Assets/SVG/Dot.svg";
import { ReactComponent as toolIcon } from "../../Assets/SVG/ToolIcon.svg";
import { ReactComponent as toolSmallIcon } from "../../Assets/SVG/Tool_Small.svg";
import { ReactComponent as cloudIcon } from "../../Assets/SVG/Cloud.svg";
import { ReactComponent as noCloudIcon } from "../../Assets/SVG/NoCloud.svg";
import { ReactComponent as usbIcon } from "../../Assets/SVG/USBPowered.svg";
import { ReactComponent as battery100Icon } from "../../Assets/SVG/Battery100.svg";
import { ReactComponent as battery80Icon } from "../../Assets/SVG/Battery80.svg";
import { ReactComponent as battery60Icon } from "../../Assets/SVG/Battery60.svg";
import { ReactComponent as battery40Icon } from "../../Assets/SVG/Battery40.svg";
import { ReactComponent as battery20Icon } from "../../Assets/SVG/Battery20.svg";
import { ReactComponent as battery10Icon } from "../../Assets/SVG/Battery10.svg";
import { ReactComponent as batteryLowIcon } from "../../Assets/SVG/BatteryLow.svg";
import { ReactComponent as minGraphIcon } from "../../Assets/SVG/MinGraph.svg";
import { ReactComponent as maxGraphIcon } from "../../Assets/SVG/MaxGraph.svg";
import { ReactComponent as userIcon } from "../../Assets/SVG/User.svg";
import { ReactComponent as clearIcon } from "../../Assets/SVG/Clear_Small.svg";
import { ReactComponent as deleteIcon } from "../../Assets/SVG/Delete.svg";
import { ReactComponent as warningIcon } from "../../Assets/SVG/Warning.svg";
import { ReactComponent as messageIcon } from "../../Assets/SVG/Messages.svg";
import { ReactComponent as channelIcon } from "../../Assets/SVG/Channel.svg";
import { ReactComponent as selectedIcon } from "../../Assets/SVG/RadioSelected.svg";
import { ReactComponent as unselectedIcon } from "../../Assets/SVG/RadioUnselected.svg";
import { ReactComponent as syncPendingIcon } from "../../Assets/SVG/SyncPending.svg";
import { ReactComponent as infoIcon } from "../../Assets/SVG/Info.svg";
import { ReactComponent as pending } from "../../Assets/SVG/Pending.svg";
import dayjs from "dayjs";
import { channelColors } from "../../global";
// import { Menu, MenuItem, MenuDivider } from 'react-native-material-menu';
import _, { values } from "lodash";
import { has } from "ramda";
import {
  Paper,
  Text,
  Group,
  Space,
  ThemeIcon,
  ActionIcon,
  Tooltip,
} from "@mantine/core";

const styles = {
  row: {
    borderBottom: "1px solid",
    borderBottomColor: Colors.lineDivider,
  },
  toggleRow: {
    borderTop: "1px solid",
    borderTopColor: Colors.lineDivider,
  },
  lightRow: {
    // ...Helpers.row,
    display: "flex",
    borderBottom: "1px solid",
    borderBottomColor: Colors.lineDivider,
  },
  section: {
    backgroundColor: Colors.lineDivider,
  },
  itemWrapper: {
    paddingBottom: 8,
  },
  item: {
    display: "flex",
    flex: 0,
    flexDirection: "row",
    // paddingLeft: Spacing.sm,
    // minHeight:Spacing.compWidth
  },
  itemIcon: {
    display: "flex",
    width: 48,
    alignItems: "center",
    justifyContent: "center",
  },
  rightIcon: {
    display: "flex",
    width: 48,
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  rightText: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  itemTitle: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center",
  },
  toolTitle: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "flex-start",
    flex: 5,
  },
  sectionTitle: {
    // display:'flex',
    flex: 1,
    paddingBottom: 0,
    marginBottom: 0,
    justifyContent: "flex-end",
    textTransform: "uppercase",
  },
  overviewTitle: {
    display: "flex",
    flex: 1,
    paddingBottom: 0,
    marginBottom: 0,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  overviewStats: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-around",
  },
  overviewStat: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  itemValue: {
    display: "flex",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "center",
  },
  itemArrow: {
    width: 32,
    alignItems: "flex-end",
    justifyContent: "center",
  },
  headerContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: 8,
    alignItems: "flex-start",
    flex: 2,
  },
  symbolContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    ...Metrics.horizontalMargin,
  },
  symbolContainerLargeMargin: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 20,
    marginLeft: 12,
  },
  overviewTab: {
    display: "flex",
    flex: 1,
    ...Metrics.tinyTopMargin,
    ...Metrics.smallHorizontalMargin,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  alertNotification: {
    display: "flex",
    width: 20,
    height: 20,
    borderRadius: 20 / 2,
    zIndex: 2, // works on ios
    // elevation: 100, // works on android
    left: 24,
    top: 4,
    paddingBottom: 4,
    paddingRight: 1,
    // position: 'absolute',
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.error,
    marginLeft: -6,
    marginBottom: 18,
  },
  alertNotificationText: {
    width: 28,
    height: 28,
    borderRadius: 28 / 2,
    zIndex: 3, // works on ios
    left: 24,
    top: -1,
    // position: 'absolute',
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.transparent,
  },
  leftUnselected: {
    display: "flex",
    cursor: "pointer",
    border: "2px solid",
    borderColor: Colors.vlightGrey,
    borderRightColor: Colors.lightGrey,
    // borderWidth:1,
    // borderRightWidth:0,
    // borderColor:Colors.vlightGrey,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: 23,
    borderBottomLeftRadius: 23,
  },
  leftSelected: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    backgroundColor: Colors.lightGrey,
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: 23,
    borderBottomLeftRadius: 23,
  },
  rightUnselected: {
    display: "flex",
    border: "2px solid",
    cursor: "pointer",
    borderColor: Colors.vlightGrey,
    borderLeftColor: Colors.lightGrey,
    // borderWidth:1,
    // borderLeftWidth:0,
    // borderColor:Colors.vlightGrey,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    borderTopRightRadius: 23,
    borderBottomRightRadius: 23,
  },
  rightSelected: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    backgroundColor: Colors.lightGrey,
    alignItems: "center",
    justifyContent: "center",
    borderTopRightRadius: 23,
    borderBottomRightRadius: 23,
  },
  button: {
    width: "48%",
  },
};

const Row = ({ children }) => (
  <View style={styles.row} padding="sm" gutter="none">
    {Children.map(children, (child, i) => {
      const itemStyle = styles.itemWrapper;
      if (i === Children.count(children)) {
        itemStyle.paddingBottom = 0;
      }
      return (
        <View key={index} style={itemStyle}>
          {child}
        </View>
      );
    })}
  </View>
);

Row.AuthInput = ({
  style,
  label,
  icon,
  value,
  setValue,
  error,
  setError,
  hidden,
  setHidden,
  children,
  ...rest
}) => {
  let keyboardType = "email-address";
  let autoCapitalize = "none";
  let secureTextEntry = false;
  let icon2 = hideIcon;
  if (hidden) {
    secureTextEntry = hidden;
    icon2 = showIcon;
  }
  if (
    label == "Password" ||
    label == "Confirm Password" ||
    label == "Old Password" ||
    label == "New Password" ||
    label == "Confirm New Password"
  ) {
    keyboardType = "default";
  } else if (label == "Phone Number" || label == "Verification Code") {
    keyboardType = "number-pad";
  }
  return (
    <View style={Helpers.rowCross}>
      {icon ? (
        <View style={{ width: 44, padding: 14 }}>
          <Icon svg={icon} color={Colors.darkGrey} size="xs" />
        </View>
      ) : (
        <></>
      )}
      <View>
        <Text as="medium" color="darkGrey">
          {label}
        </Text>
        {!(
          label == "Password" ||
          label == "Confirm Password" ||
          label == "Old Password" ||
          label == "New Password" ||
          label == "Confirm New Password"
        ) ? (
          <Input
            style={{
              textAlign: "left",
              color: Colors.darkGrey,
              paddingLeft: 10,
              ...Fonts.medium,
              fontFamily: "Inter-Regular",
              flex: 1,
            }} //medium
            autoCapitalize={autoCapitalize}
            secureTextEntry={secureTextEntry}
            label={label}
            textColor={Colors.darkGrey}
            baseColor={Colors.lightGrey}
            tintColor={Colors.primary}
            selectionColor={Colors.highlight}
            labelFontSize={size.medium}
            keyboardType={keyboardType}
            selectTextOnFocus={true}
            lineWidth={1}
            disabledLineWidth={1}
            activeLineWidth={1}
            inputContainerStyle={{
              width: "100%",
              backgroundColor: Colors.white,
            }}
            containerStyle={{ width: "100%", backgroundColor: Colors.white }}
            value={value}
            status={error ? "error" : ""}
            onFocus={() => {
              if (setError) {
                setError("");
              }
            }}
            renderLeftAccessory={() => {
              return icon ? (
                // 44 = 28 for margin + 16 for icon
                <View style={{ width: 44, padding: 14 }}>
                  <Icon svg={icon} color={Colors.darkGrey} size="xs" />
                </View>
              ) : (
                <></>
              );
            }}
            //renderRightAccessory={rightIcon}
            onChange={(event) => {
              setValue(event.target.value);
            }}
          />
        ) : (
          <View style={Helpers.rowCross}>
            <Input.Password
              styles={{
                input: {
                  textAlign: "left",
                  color: Colors.darkGrey,
                  ...Fonts.medium,
                  fontFamily: "Inter-Regular",
                  flex: 1,
                },
              }}
              visibilityToggle={{ visible: hidden, onVisibleChange: setHidden }}
              autoCapitalize={autoCapitalize}
              secureTextEntry={secureTextEntry}
              label={label}
              textColor={Colors.darkGrey}
              baseColor={Colors.lightGrey}
              tintColor={Colors.primary}
              selectionColor={Colors.highlight}
              labelFontSize={size.medium}
              keyboardType={keyboardType}
              selectTextOnFocus={true}
              lineWidth={1}
              disabledLineWidth={1}
              activeLineWidth={1}
              inputContainerStyle={{
                width: "100%",
                backgroundColor: Colors.white,
              }}
              containerStyle={{ width: "100%", backgroundColor: Colors.white }}
              value={value}
              status={error ? "error" : ""}
              onFocus={() => {
                if (setError) {
                  setError("");
                }
              }}
              renderLeftAccessory={() => {
                return icon ? (
                  // 44 = 28 for margin + 16 for icon
                  <View style={{ width: 44, padding: 14 }}>
                    <Icon svg={icon} color={Colors.darkGrey} size="xs" />
                  </View>
                ) : (
                  <></>
                );
              }}
              renderRightAccessory={() => {
                return (
                  // 44 = 28 for margin + 16 for icon
                  <View
                    onPress={() => {
                      setHidden(!secureTextEntry);
                    }}
                  >
                    <View style={{ width: 44, padding: 14 }}>
                      <Icon svg={icon2} color={Colors.lightGrey} size="sm" />
                    </View>
                  </View>
                );
              }}
              onChange={(event) => {
                setValue(event.target.value);
              }}
            />
          </View>
        )}
      </View>
    </View>
  );
};
Row.Overview = ({
  style,
  children,
  toggle,
  setToggle,
  tool,
  tab,
  setTab,
  setNoScroll,
  alerts,
  usbPowered,
  clearSelection,
  ...rest
}) => {
  let alertLength = 0;
  if (!_.isEmpty(alerts)) {
    alertLength = 0;
    alerts.forEach((alert) => {
      alertLength += alert.alertState.alertCnt;
    });
    alertLength = alertLength.toFixed(0);
  }

  let lastTime = "-";
  let date = null;
  let live = false;
  let timeElapsedString = "-";
  if (!_.isEmpty(tool.sensor)) {
    lastTime = tool.sensor.updatedAt;
    date = new Date(lastTime * 1000);
    live = sensorLive.isLive(lastTime);
    timeElapsedString = sensorLive.getTimeElapsedString(lastTime);
  }
  let batteryLvl =
    _.has(tool, "toolSystem") &&
    !_.isEmpty(tool.toolSystem) &&
    tool.toolSystem.sysBatteryLvl
      ? tool.toolSystem.sysBatteryLvl
      : undefined;
  let cloudConnected = false;
  if (_.has(tool, "nextUpdateTS"))
    cloudConnected = HelperService.isCloudConnected(tool.nextUpdateTS);

  //,{paddingVertical: 16}
  // padding="sm"

  return (
    <View style={{ ...styles.lightRow }}>
      <View
        style={[
          Helpers.row,
          Helpers.mainSpaceBetween,
          Helpers.fill,
          { height: 40 },
        ]}
      >
        <View style={[Helpers.row, Helpers.fill, Helpers.mainSpaceBetween]}>
          <View
            style={[
              styles.overviewTab,
              { backgroundColor: tab == 0 ? Colors.light : "transparent" },
            ]}
            onClick={() => {
              clearSelection();
              setTab(0);
              setNoScroll(false);
            }}
          >
            <Icon
              svg={graphIcon}
              size="s20"
              color={tab == 0 ? Colors.secondary : Colors.lightGrey}
            />
          </View>
          <View
            style={[
              styles.overviewTab,
              {
                zIndex: 2,
                backgroundColor: tab == 1 ? Colors.light : "transparent",
              },
            ]}
            onClick={() => {
              clearSelection();
              setTab(1);
              setNoScroll(true);
            }}
          >
            <Icon
              svg={alertIcon}
              size="s20"
              color={tab == 1 ? Colors.secondary : Colors.lightGrey}
            />
            {/* {!_.isEmpty(alerts) && alertLength != '0' &&
              <View style ={[styles.alertNotificationText,{width:alertLength.length>1?(20+(12*(alertLength.length-1))):20}]}></View>
            } */}
            {!_.isEmpty(alerts) && alertLength != "0" && (
              <View
                style={[
                  styles.alertNotification,
                  {
                    width:
                      alertLength.length > 1
                        ? 20 + 12 * (alertLength.length - 1)
                        : 20,
                  },
                ]}
              >
                <View>
                  <Text as="small" color="white">
                    {alertLength}
                  </Text>
                </View>
              </View>
            )}
          </View>
          <View
            style={[
              styles.overviewTab,
              {
                zIndex: 1,
                backgroundColor: tab == 2 ? Colors.light : "transparent",
              },
            ]}
            onClick={() => {
              clearSelection();
              setTab(2);
              setNoScroll(false);
            }}
          >
            <Icon
              svg={prefIcon}
              size="s20"
              color={tab == 2 ? Colors.secondary : Colors.lightGrey}
            />
          </View>
        </View>
        <View
          style={[
            Helpers.row,
            Helpers.fill,
            Helpers.mainEnd,
            { backgroundColor: "transparent" },
          ]}
        >
          {/* {live?(
            <></>
          ):(
            <View style={[Helpers.center,Metrics.horizontalPadding]} onPress={()=>console.log("Refresh")}>
              <Icon svg={syncIcon} size="xs" color={Colors.vlightGrey}/>
            </View>
          )}          */}
          <View
            style={[
              Helpers.rowCross,
              { width: 110, justifyContent: "flex-end", cursor: "pointer" },
            ]}
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            {toggle ? (
              <Tooltip
                color={Colors.darkGrey}
                title="Time of last post"
                arrow={{ pointAtCenter: true }}
                placement="topRight"
              >
                <Text style={Helpers.textRight} as="small" color="vlightGrey">
                  {timeElapsedString}
                </Text>
              </Tooltip>
            ) : (
              <Tooltip
                color={Colors.darkGrey}
                title="Time of last post"
                arrow={{ pointAtCenter: true }}
                placement="topRight"
              >
                <Text style={Helpers.textRight} as="small" color="vlightGrey">
                  {date == null
                    ? ""
                    : HelperService.formatTime(date, 0) +
                      "\n" +
                      HelperService.formatDate(date, 0)}
                </Text>
              </Tooltip>
            )}
          </View>
          <View style={[styles.symbolContainerLargeMargin, Helpers.rowCross]}>
            {usbPowered == undefined ? (
              <></>
            ) : usbPowered ? (
              <Tooltip
                color={Colors.darkGrey}
                title={"USB Powered"}
                arrow={{ pointAtCenter: true }}
                placement="topRight"
              >
                <Icon svg={usbIcon} size="xs" color={Colors.lightGrey} />
              </Tooltip>
            ) : (
              <Tooltip
                color={Colors.darkGrey}
                title={"Battery " + batteryLvl + "%"}
                arrow={{ pointAtCenter: true }}
                placement="topRight"
              >
                <Icon
                  svg={
                    batteryLvl == 100
                      ? battery100Icon
                      : batteryLvl >= 80
                      ? battery80Icon
                      : batteryLvl >= 60
                      ? battery60Icon
                      : batteryLvl >= 40
                      ? battery40Icon
                      : batteryLvl >= 20
                      ? battery20Icon
                      : batteryLvl >= 10
                      ? battery10Icon
                      : batteryLowIcon
                  }
                  size="xs"
                />
              </Tooltip>
            )}
            {cloudConnected ? (
              <Tooltip
                color={Colors.darkGrey}
                title={"Cloud Connected"}
                arrow={{ pointAtCenter: true }}
                placement="topRight"
              >
                <Icon svg={cloudIcon} size="xs" color={Colors.lightGrey} />
              </Tooltip>
            ) : (
              <Tooltip
                color={Colors.darkGrey}
                title={"Not Cloud Connected"}
                arrow={{ pointAtCenter: true }}
                placement="topRight"
              >
                <Icon svg={noCloudIcon} size="xs" color={Colors.lightGrey} />
              </Tooltip>
            )}
          </View>
        </View>
      </View>
      {children}
    </View>
  );
};

Row.OverviewLink = ({
  style,
  title,
  noBorder,
  first,
  onPress,
  children,
  ...rest
}) => {
  const sectionPadding = first ? { paddingTop: 16 } : { paddingTop: 32 };
  const component = (
    <View
      {...rest}
      style={
        noBorder
          ? [styles.item, { ...sectionPadding }, style]
          : [styles.lightRow, styles.item, { ...sectionPadding }, style]
      }
      padding="md"
      gutter="none"
      sidePadding="md"
    >
      <View style={styles.toolTitle}>
        <Text as="medium" color="darkGrey">
          {title}
        </Text>
      </View>
      {onPress && (
        <View style={styles.rightIcon}>
          <Icon color={Colors.secondary} svg={plusIcon} size="xs" />
        </View>
      )}

      {children}
    </View>
  );

  if (onPress) {
    return <View onPress={onPress}>{component}</View>;
  }
  return component;
};

Row.OverviewSection = ({
  style,
  title,
  value,
  unit,
  children,
  first,
  icons,
  high,
  low,
  avg,
  time,
  ...rest
}) => {
  return (
    <View paddingTop="5%">
      <View
        {...rest}
        style={[styles.row, styles.overviewTitle]}
        padding="sm"
        gutter="none"
      >
        <View>
          <Text as="large" color="dark">
            {title}
          </Text>
          <Text as="xxlarge" color="dark" weight="bold">
            {value + " " + unit}
          </Text>
        </View>
        <View style={{ justifyContent: "flex-end", alignItems: "flex-end" }}>
          <Text as="medium" color="hint">
            {time}
          </Text>
          <Text as="small" color="hint">
            Last Measurement
          </Text>
        </View>
      </View>
      <View
        {...rest}
        style={[styles.row, styles.overviewStats]}
        padding="sm"
        gutter="none"
      >
        <View style={styles.overviewStat}>
          <Text as="large" color="hint" weight="bold">
            {high}
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Icon svg={highIcon} size="xs" />
            <Text as="medium" color="hint">
              {" High"}
            </Text>
          </View>
        </View>
        <View
          style={[
            styles.overviewStat,
            {
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderColor: Colors.dark,
            },
          ]}
        >
          <Text as="large" color="hint" weight="bold">
            {low}
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Icon svg={lowIcon} size="xs" />
            <Text as="medium" color="hint">
              {" Low"}
            </Text>
          </View>
        </View>
        <View style={styles.overviewStat}>
          <Text as="large" color="hint" weight="bold">
            {avg}
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Icon svg={equalIcon} size="xs" />
            <Text as="medium" color="hint">
              {" Avg"}
            </Text>
          </View>
        </View>
      </View>
      {children}
    </View>
  );
};

Row.Section = ({ style, icon, title, children, button, stats, ...rest }) => {
  return (
    <View
      {...rest}
      style={{
        ...styles.section,
        ...style,
        height: size.small + 2 * Spacing.sm,
        paddingLeft: Spacing.md,
      }}
      padding="xm"
      gutter="none"
    >
      {icon && (
        <View style={styles.itemIcon}>
          <Icon svg={icon} size="sm" />
        </View>
      )}
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {title && (
          <Text as="small" color="darkGrey" style={{ ...styles.sectionTitle }}>
            {title}
          </Text>
        )}
        {stats ? (
          <View style={Helpers.row}>
            <View style={{ width: "50%", alignSelf: "center" }}></View>
            <View
              style={{
                ...Helpers.row,
                ...Helpers.textCenter,
                width: "50%",
                alignSelf: "center",
              }}
            >
              <View style={{ flex: 1 }}>
                <Text style={Helpers.textCenter} as="small" color="lightGrey">
                  {"High"}
                </Text>
              </View>
              <View style={{ flex: 1 }}>
                <Text style={Helpers.textCenter} as="small" color="lightGrey">
                  {"Low"}
                </Text>
              </View>
              <View style={{ flex: 1 }}>
                <Text style={Helpers.textCenter} as="small" color="lightGrey">
                  {"Avg"}
                </Text>
              </View>
            </View>
          </View>
        ) : (
          <></>
        )}
        {button && (
          <View
            onPress={() => {
              console.log("Make new project");
            }}
          >
            <Icon svg={plusIcon} color={Colors.primary} size="xs" />
          </View>
          // <Button
          //   style={{width:180}}
          //   icon={{ icon: plusIcon, size: 'xs', color: Colors.dark }}
          //   text=" New Group"
          //   both = {true}
          //   variant="primary-transparent"
          //   onPress={() => {
          //     console.log("Make new project")
          //   }}
          // />)
        )}
      </View>
    </View>
  );
};

Row.Subsection = ({ style, icon, title, children, first, ...rest }) => {
  const sectionPadding = first ? { paddingTop: 0 } : { paddingTop: 24 };
  return (
    <View>
      <View
        {...rest}
        style={[styles.row, styles.item, style]}
        padding="sm"
        gutter="none"
      >
        {icon && (
          <View style={styles.itemIcon}>
            <Icon svg={icon} size="sm" />
          </View>
        )}
        <View>
          <Text
            as="small"
            color="dark"
            weight="bold"
            style={{ ...styles.sectionTitle, ...sectionPadding }}
          >
            {title}
          </Text>
        </View>
      </View>
      {children}
    </View>
  );
};

// Children on all rows below are for activated elements based on an action, example picker display
Row.Value = ({
  style,
  icon,
  title,
  value,
  onPress,
  color,
  children,
  ...rest
}) => {
  const component = (
    <View
      {...rest}
      style={[styles.lightRow, styles.item, style]}
      padding="md"
      gutter="none"
      sidePadding="md"
    >
      {icon && color ? (
        <View style={styles.itemIcon}>
          <Icon svg={icon} size="xs" color={color} />
        </View>
      ) : icon ? (
        <View style={styles.itemIcon}>
          <Icon svg={icon} size="xs" />
        </View>
      ) : (
        <></>
      )}
      <View
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View style={styles.itemTitle}>
          <Text as="large" color="darkGrey" weight="light">
            {title}
          </Text>
        </View>
        <View
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        >
          <Text as="small" color="vlightGrey">
            {value}
          </Text>
        </View>
      </View>
      {onPress && (
        <View style={styles.itemArrow}>
          <Icon color={Colors.light} svg={disclosureIcon} size="xs" />
        </View>
      )}
      {children}
    </View>
  );

  if (onPress) {
    return <View onPress={onPress}>{component}</View>;
  }
  return component;
};

// Children on all rows below are for activated elements based on an action, example picker display
Row.Tool = ({ style, title, toolType, state, onPress, children, ...rest }) => {
  let icon = toolIcon;
  switch (toolType) {
    case ToolTypes.THP:
    case ToolTypes.SDP:
      icon = thpIcon;
      break;
    case ToolTypes.ANALOG_4_CH:
      icon = analogIcon;
    case ToolTypes.THERMO_4_CH:
      icon = therm4Icon;
      break;
    case ToolTypes.SWIM:
      icon = swimIcon;
      break;
    case ToolTypes.CHEM:
      icon = chemIcon;
      break;
    default:
      break;
  }

  const component = (
    <View
      {...rest}
      style={[styles.lightRow, styles.item, style]}
      padding="md"
      gutter="none"
    >
      {state == true ? (
        <View style={styles.itemIcon}>
          <Icon svg={closeIcon} size="xs" />
        </View>
      ) : (
        <View style={styles.itemIcon}>
          <Icon svg={icon} size="md" />
        </View>
      )}
      <View style={styles.toolTitle}>
        <Text as="small" color="darkGrey" weight="bold">
          {title}
        </Text>
        <Text as="small" color="vlightGrey">
          {toolType}
        </Text>
      </View>

      {children}
    </View>
  );

  if (onPress) {
    return <View onPress={onPress}>{component}</View>;
  }
  return component;
};

Row.Folder = ({
  style,
  title,
  addSelected,
  removeSelected,
  selectMode,
  sessions,
  lastSelected,
  selected,
  folders,
  ...rest
}) => {
  const [open, setOpen] = useState(false);

  const component = (
    <View style={[{ cursor: "pointer", backgroundColor: Colors.white }]}>
      <View
        {...rest}
        style={[styles.lightRow, styles.item, style, { flex: 1 }]}
        padding="sm"
        gutter="none"
      >
        <View
          onClick={(e) => e.stopPropagation()}
          style={{ ...styles.symbolContainerLargeMargin, marginRight: 0 }}
        >
          <Checkbox
            onChange={(e) => {
              e.stopPropagation();
              let multiple = e.nativeEvent.shiftKey;
              if (selected.includes(title)) {
                removeSelected(title);
                // setSelected(false)
              } else {
                if (selectMode == "false" || selectMode == "folder") {
                  addSelected(title, "folder");
                  // setSelected(true)
                }
              }
              // if(selected.includes(alert.alert_id)){
              //   if(multiple && lastSelected){
              //     let currentIndex = _.findIndex(alerts,(a)=>a.alert_id == alert.alert_id)
              //     let lastIndex = _.findIndex(alerts,(a)=>a.alert_id == lastSelected)
              //     let lowIndex = Math.min(lastIndex,currentIndex)
              //     let highIndex = Math.max(lastIndex,currentIndex)
              //     alerts.forEach((item,index)=>{
              //       if(index>=lowIndex && index<=highIndex && index!=currentIndex && selected.includes(item.alert_id)){
              //         removeSelected(item.alert_id)
              //       }
              //     })
              //   }
              //   removeSelected(alert.alert_id)
              // }else{
              //   if(multiple && lastSelected){
              //     let currentIndex = _.findIndex(alerts,(a)=>a.alert_id == alert.alert_id)
              //     let lastIndex = _.findIndex(alerts,(a)=>a.alert_id == lastSelected)
              //     let lowIndex = Math.min(lastIndex,currentIndex)
              //     let highIndex = Math.max(lastIndex,currentIndex)
              //     alerts.forEach((item,index)=>{
              //       if(index>=lowIndex && index<=highIndex && index!=currentIndex && !selected.includes(item.alert_id)){
              //         addSelected(item.alert_id)
              //       }
              //     })
              //   }
              //   addSelected(alert.alert_id)
              // }
            }}
            onClick={(e) => e.stopPropagation()}
            checked={selected.includes(title)}
            style={{
              width: 32,
              height: 32,
            }}
          />
        </View>
        <View style={styles.itemIcon}>
          <Icon svg={folderIcon} size="md" />
        </View>
        <View style={[styles.toolTitle, Helpers.column]}>
          <Text as="medium" color="black" weight="bold">
            {title}
          </Text>
        </View>
        {sessions.type === React.Fragment ? (
          <></>
        ) : open ? (
          <View
            style={{ ...Metrics.smallHorizontalMargin, alignSelf: "center" }}
            onPress={() => setOpen(false)}
          >
            <Icon color={Colors.lightGrey} svg={arrowDown} size="s10" />
          </View>
        ) : (
          <View
            style={{ ...Metrics.smallHorizontalMargin, alignSelf: "center" }}
            onPress={() => setOpen(true)}
          >
            <Icon color={Colors.lightGrey} svg={arrowUp} size="s10" />
          </View>
        )}
      </View>
      {open ? sessions : <></>}
    </View>
  );

  return (
    <View
      onClick={(e) => {
        e.stopPropagation();
        if (sessions.type !== React.Fragment) {
          if (open) {
            setOpen(false);
          } else {
            setOpen(true);
          }
        }
      }}
    >
      {component}
    </View>
  );
};

// Children on all rows below are for activated elements based on an action, example picker display
Row.Session = ({
  style,
  title,
  onPress,
  sessionID,
  addSelected,
  removeSelected,
  selectMode,
  inFolder,
  getToolName,
  sessions,
  lastSelected,
  selected,
  currentSession,
  ...rest
}) => {
  // const dispatch = useDispatch()
  // const pressTimer = useRef(null)
  // const [longPress,setLongPress] = useState(false)
  // const [selected,setSelected] = useState(false)
  // if(selectMode == "false" && selected) setSelected(false)

  const component = (
    <View
      style={[
        styles.lightRow,
        {
          cursor: "pointer",
          backgroundColor:
            currentSession == sessionID ? Colors.secondary20 : Colors.white,
        },
      ]}
    >
      <View
        {...rest}
        style={[styles.item, style, { flex: 1 }]}
        padding="sm"
        gutter="none"
      >
        {inFolder ? (
          <View style={styles.itemIcon}>{/* Spacing */}</View>
        ) : (
          <></>
        )}
        <View
          onClick={(e) => e.stopPropagation()}
          style={{ ...styles.symbolContainerLargeMargin, marginRight: 0 }}
        >
          <Checkbox
            onChange={(e) => {
              e.stopPropagation();
              let multiple = e.nativeEvent.shiftKey;
              if (selected.includes(sessionID)) {
                removeSelected(sessionID);
              } else {
                if (selectMode == "false" || selectMode == "session") {
                  addSelected(sessionID, "session");
                }
              }
              // if(selected.includes(alert.alert_id)){
              //   if(multiple && lastSelected){
              //     let currentIndex = _.findIndex(alerts,(a)=>a.alert_id == alert.alert_id)
              //     let lastIndex = _.findIndex(alerts,(a)=>a.alert_id == lastSelected)
              //     let lowIndex = Math.min(lastIndex,currentIndex)
              //     let highIndex = Math.max(lastIndex,currentIndex)
              //     alerts.forEach((item,index)=>{
              //       if(index>=lowIndex && index<=highIndex && index!=currentIndex && selected.includes(item.alert_id)){
              //         removeSelected(item.alert_id)
              //       }
              //     })
              //   }
              //   removeSelected(alert.alert_id)
              // }else{
              //   if(multiple && lastSelected){
              //     let currentIndex = _.findIndex(alerts,(a)=>a.alert_id == alert.alert_id)
              //     let lastIndex = _.findIndex(alerts,(a)=>a.alert_id == lastSelected)
              //     let lowIndex = Math.min(lastIndex,currentIndex)
              //     let highIndex = Math.max(lastIndex,currentIndex)
              //     alerts.forEach((item,index)=>{
              //       if(index>=lowIndex && index<=highIndex && index!=currentIndex && !selected.includes(item.alert_id)){
              //         addSelected(item.alert_id)
              //       }
              //     })
              //   }
              //   addSelected(alert.alert_id)
              // }
            }}
            onClick={(e) => e.stopPropagation()}
            checked={selected.includes(sessionID)}
            style={{
              width: 32,
              height: 32,
            }}
          />
        </View>
        <View style={styles.itemIcon}>
          <Icon svg={sessionIcon} size="md" />
        </View>
        <View style={[styles.toolTitle, Helpers.column]}>
          <Text as="medium" color="black" weight="bold">
            {title}
          </Text>
          <Text as="small" color="hint">
            {getToolName()}
          </Text>
        </View>
      </View>
    </View>
  );

  return (
    <View
      onClick={(event) => {
        event.stopPropagation();
        onPress();
      }}
    >
      {component}
    </View>
  );
};

Row.ImageUpload = ({ title, image, setImageUpdate, width, height }) => {
  const [tempImage, setTempImage] = useState(image);
  // const [imageUpdate, setImageUpdate] = useState(null);
  useEffect(() => {
    setTempImage(image);
  }, [image]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (readEvent) => {
        if (reader.readyState === FileReader.DONE) {
          setTempImage(reader.result);
          setImageUpdate({ image: reader.result, contentType: file.type });
        }
      };
      reader.readAsDataURL(file);
    } else {
      setTempImage(image);
      setImageUpdate(null);
    }
  };

  return (
    <View style={{ ...Helpers.column, ...Metrics.mdHorizontalPadding }}>
      <Text as="medium" color="darkGrey">
        {title}
      </Text>
      {tempImage ? (
        <img
          style={{ height: height ? height : 180, width: width ? width : 300 }}
          src={tempImage}
          mode="fit"
        />
      ) : (
        <View
          style={{
            height: height ? height : 180,
            width: width ? width : 300,
            ...Helpers.center,
            border: `1px solid ${Colors.lineDivider}`,
          }}
        >
          <Text as="medium" color="textMain" style={{ ...Helpers.center }}>
            No Image
          </Text>
        </View>
      )}
      <View style={{ ...Helpers.row, ...Metrics.verticalPadding }}>
        <input type="file" onChange={handleFileChange} />
      </View>
    </View>
  );
};

Row.ToolGraphOptions = ({
  style,
  children,
  setFullscreen,
  fullscreen,
  startValue,
  endValue,
  onPressEndDate,
  onPressStartDate,
  onChangeStartDate,
  onChangeEndDate,
  min,
  max,
  navToGraphProps,
  navToExport,
  tool,
  zoom,
  resetZoom,
  ...rest
}) => {
  //,setZoom,zoom
  let hasUpper = false;
  let hasLower = false;
  let hasDatePickers = false;
  if (
    startValue &&
    endValue &&
    onPressEndDate &&
    onPressStartDate &&
    onChangeStartDate &&
    onChangeEndDate
  )
    hasDatePickers = true;
  if (tool && _.has(tool, "alerts") && !_.isEmpty(tool.alerts)) {
    tool.alerts.forEach((alert) => {
      if (
        alert.alertMode == "sensorMode" &&
        alert.settings.alertEnable == true &&
        alert.settings.testField == "sthp_temp"
      ) {
        if (alert.settings.testCondition == "GT") {
          hasUpper = true;
        }
        if (alert.settings.testCondition == "LS") {
          hasLower = true;
        }
      }
    });
  }
  const component = //width:(hasDatePickers?"33.3%":"50%")
    (
      <Paper p="xl">
        <Group justify="space-between">
          <Group>
            <Group gap="xs">
              <ThemeIcon radius="xl" size={13} color={Colors.greenMain} />
              <Text size="xs" fw={500} c="dimmed">
                Temperature
              </Text>
            </Group>

            {hasUpper && (
              <Group gap="xs">
                <ThemeIcon radius="xl" size={13} color={Colors.orangeMain} />
                <Text size="xs" fw={500} c="dimmed">
                  Upper Threshold
                </Text>
              </Group>
            )}
            {hasLower && (
              <Group gap="xs">
                <ThemeIcon radius="xl" size={13} color={Colors.redMain} />
                <Text size="xs" fw={500} c="dimmed">
                  Lower Threshold
                </Text>
              </Group>
            )}
          </Group>

          {hasDatePickers && (
            <Group>
              <Text size="sm" fw={500}>
                Date
              </Text>
              <View
                style={{ flex: 1, justifyContent: "center" }}
                onPress={onPressStartDate}
              >
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <DatePicker
                    textColor={Colors.light}
                    style={{ width: "100%" }}
                    testID="startDatePicker"
                    value={dayjs(startValue)}
                    is24Hour={false}
                    format={"MMM DD, YYYY"}
                    onChange={onChangeStartDate}
                    minimumDate={min ? min : null}
                    maximumDate={max ? max : null}
                  />
                </View>
              </View>
              <Text size="sm" fw={500}>
                To
              </Text>
              <View
                style={{ flex: 1, justifyContent: "center" }}
                onPress={onPressEndDate}
              >
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <DatePicker
                    textColor={Colors.light}
                    style={{ width: "100%" }}
                    testID="endDatePicker"
                    value={dayjs(endValue)}
                    is24Hour={false}
                    format={"MMM DD, YYYY"}
                    onChange={onChangeEndDate}
                    minimumDate={min ? min : null}
                    maximumDate={max ? max : null}
                  />
                </View>
              </View>
            </Group>
          )}

          {navToExport && navToGraphProps && setFullscreen && (
            <Group>
              <Tooltip label="Graph Properties">
                <ActionIcon
                  variant="subtle"
                  color={Colors.lightGrey}
                  onClick={navToGraphProps}
                >
                  <Icon
                    color={Colors.lightGrey}
                    svg={graphPropsIcon}
                    size="xs"
                  />
                </ActionIcon>
              </Tooltip>

              <Tooltip label={fullscreen ? "Shrink" : "Expand"}>
                <ActionIcon
                  variant="subtle"
                  color={Colors.lightGrey}
                  onClick={() => setFullscreen(!fullscreen)}
                >
                  <Icon
                    color={Colors.lightGrey}
                    svg={fullscreen ? fullscreenOffIcon : fullscreenIcon}
                    size="xs"
                  />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Export">
                <ActionIcon
                  variant="subtle"
                  color={Colors.lightGrey}
                  onClick={navToExport}
                >
                  <Icon
                    color={navToExport ? Colors.lightGrey : Colors.lightGrey20}
                    activeOpacity={navToExport ? 0.2 : 1}
                    svg={downloadIcon}
                    size="xs"
                  />
                </ActionIcon>
              </Tooltip>
            </Group>
          )}
          {children}
        </Group>
      </Paper>
    );

  return component;
};

Row.YAxis = ({
  style,
  children,
  name,
  channels,
  icons,
  enabledAxis,
  setEnabledAxis,
  axisIndex,
  max,
  min,
  unit,
  ...rest
}) => {
  // auto, min, max, enabled,
  let newEnabledAxis = _.cloneDeep([...enabledAxis]);
  let icon = hideIcon;
  if (enabledAxis[axisIndex].enabled) {
    icon = showIcon;
  }
  if (isNaN(max)) max = "--";
  if (isNaN(min)) min = "--";
  const [open, setOpen] = useState(false);
  const [minValue, setMinValue] = useState(false);
  const [maxValue, setMaxValue] = useState(false);
  const [minUpdated, setMinUpdated] = useState(false);
  const [maxUpdated, setMaxUpdated] = useState(false);
  const [minValueCustom, setMinValueCustom] = useState(
    newEnabledAxis[axisIndex].min.toLocaleString()
  );
  const [maxValueCustom, setMaxValueCustom] = useState(
    newEnabledAxis[axisIndex].max.toLocaleString()
  );

  let details = (
    <View
      style={[
        Helpers.row,
        styles.item,
        styles.toggleRow,
        {
          justifyContent: "flex-start",
          alignItems: "center",
          marginLeft: Spacing.xxl + Spacing.md,
          paddingRight: Spacing.md,
        },
      ]}
    >
      <View
        style={{
          ...Helpers.row,
          flex: 1,
          justifyContent: "flex-start",
          alignItems: "center",
          height: "100%",
        }}
      >
        <View
          style={[
            Helpers.row,
            Metrics.tinyHorizontalMargin,
            {
              justifyContent: "flex-start",
              alignItems: "center",
              height: "100%",
              flex: 1,
            },
          ]}
          onClick={(event) => {
            event.stopPropagation();
            if (!enabledAxis[axisIndex].auto) {
              setMinValueCustom(newEnabledAxis[axisIndex].min.toLocaleString());
              setMinUpdated(true);
              setMinValue(true);
            }
          }}
        >
          <Icon
            color={
              enabledAxis[axisIndex].auto ? Colors.vlightGrey : Colors.secondary
            }
            svg={minGraphIcon}
            size="xs"
          />
          <View style={{ flex: 1 }}>
            <Text
              as={"small"}
              c={enabledAxis[axisIndex].auto ? "vlightGrey" : "darkGrey"}
            >
              {enabledAxis[axisIndex].auto && min == "--"
                ? " -- " + unit
                : enabledAxis[axisIndex].auto
                ? " " + parseFloat(min).toFixed(2) + " " + unit
                : " " + minValueCustom + " " + unit}
            </Text>
          </View>
        </View>
        <View
          style={[
            Helpers.row,
            Metrics.tinyHorizontalMargin,
            {
              justifyContent: "flex-start",
              alignItems: "center",
              height: "100%",
              flex: 1,
            },
          ]}
          onClick={(event) => {
            event.stopPropagation();
            if (!enabledAxis[axisIndex].auto) {
              setMaxValueCustom(newEnabledAxis[axisIndex].max.toLocaleString());
              setMaxUpdated(true);
              setMaxValue(true);
            }
          }}
        >
          <Icon
            color={
              enabledAxis[axisIndex].auto ? Colors.vlightGrey : Colors.secondary
            }
            svg={maxGraphIcon}
            size="xs"
          />
          <View style={{ flex: 1 }}>
            <Text
              as={"small"}
              color={enabledAxis[axisIndex].auto ? "vlightGrey" : "darkGrey"}
            >
              {enabledAxis[axisIndex].auto && max == "--"
                ? " -- " + unit
                : enabledAxis[axisIndex].auto
                ? " " + parseFloat(max).toFixed(2) + " " + unit
                : " " + maxValueCustom + " " + unit}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
  const component = (
    <View
      style={[
        styles.lightRow,
        { backgroundColor: Colors.white },
        Helpers.column,
      ]}
      sidePadding="md"
      gutter="none"
    >
      <View {...rest} style={[styles.item, style]}>
        <View
          style={[
            {
              display: "flex",
              flex: 1,
              justifyContent: "flex-start",
              alignItems: "center",
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginLeft: Spacing.sm,
            },
            Helpers.row,
          ]}
          onClick={() => {
            // if(open){
            //   setOpen(false)
            // }else{
            //   setOpen(true)
            // }
          }}
        >
          <Text as="medium" color={"darkGrey"} weight={"medium"}>
            {name + "  "}
          </Text>
          <View
            style={{
              ...Helpers.row,
              flex: 1,
              justifyContent: "space-around",
              alignItems: "center",
              height: "100%",
            }}
          >
            <View
              style={[
                Helpers.row,
                Metrics.tinyHorizontalMargin,
                {
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  flex: 1,
                },
              ]}
              onClick={(event) => {
                event.stopPropagation();
                if (!enabledAxis[axisIndex].auto) {
                  setMinValueCustom(
                    newEnabledAxis[axisIndex].min.toLocaleString()
                  );
                  setMinUpdated(true);
                  setMinValue(true);
                }
              }}
            >
              <Icon
                color={
                  enabledAxis[axisIndex].auto
                    ? Colors.vlightGrey
                    : Colors.secondary
                }
                svg={minGraphIcon}
                size="xs"
              />
              <Text
                as={"small"}
                color={enabledAxis[axisIndex].auto ? "vlightGrey" : "darkGrey"}
              >
                {enabledAxis[axisIndex].auto && min == "--"
                  ? " -- " + unit
                  : enabledAxis[axisIndex].auto
                  ? " " + parseFloat(min).toFixed(2) + " " + unit
                  : " " + minValueCustom + " " + unit}
              </Text>
            </View>
            <View
              style={[
                Helpers.row,
                Metrics.tinyHorizontalMargin,
                {
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  flex: 1,
                },
              ]}
              onClick={(event) => {
                event.stopPropagation();
                if (!enabledAxis[axisIndex].auto) {
                  setMaxValueCustom(
                    newEnabledAxis[axisIndex].max.toLocaleString()
                  );
                  setMaxUpdated(true);
                  setMaxValue(true);
                }
              }}
            >
              <Icon
                color={
                  enabledAxis[axisIndex].auto
                    ? Colors.vlightGrey
                    : Colors.secondary
                }
                svg={maxGraphIcon}
                size="xs"
              />
              <Text
                as={"small"}
                color={enabledAxis[axisIndex].auto ? "vlightGrey" : "darkGrey"}
              >
                {enabledAxis[axisIndex].auto && max == "--"
                  ? " -- " + unit
                  : enabledAxis[axisIndex].auto
                  ? " " + parseFloat(max).toFixed(2) + " " + unit
                  : " " + maxValueCustom + " " + unit}
              </Text>
            </View>
          </View>
        </View>
        {children}
      </View>
      {/* {open?details:<></>} */}
      <Alert
        visible={minValue}
        setVisible={setMinValue}
        title="Enter Minimum Value"
        defaultValue={minValueCustom}
        valueUpdated={minUpdated}
        numericInput={"Minimum Value (" + unit + ")"}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onPress={(number) => {
          newEnabledAxis[axisIndex].min = Number(number);
          setMinValueCustom(number);
          console.log("YAxis setEnabledAxis", newEnabledAxis);
          setEnabledAxis(newEnabledAxis);
        }}
      />
      <Alert
        visible={maxValue}
        setVisible={setMaxValue}
        title="Enter Max Value"
        defaultValue={maxValueCustom}
        valueUpdated={maxUpdated}
        numericInput={"Max Value (" + unit + ")"}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onPress={(number) => {
          console.log("NEW MAX:", number);
          console.log("newEnabledAxis:", newEnabledAxis);
          console.log("axisIndex:", axisIndex);
          newEnabledAxis[axisIndex].max = Number(number);
          console.log("NEW MAX:", Number(number));
          setMaxValueCustom(number);
          console.log("YAxis setEnabledAxis:", newEnabledAxis);
          setEnabledAxis(newEnabledAxis);
        }}
      />
    </View>
  );

  return <View activeOpacity={1}>{component}</View>;
};

Row.Message = ({
  style,
  children,
  message,
  addSelected,
  removeSelected,
  selectMode,
  toolType,
  tool,
  updateCallback,
  messages,
  lastSelected,
  selected,
  ...rest
}) => {
  const navigate = useNavigate();
  let icon = toolIcon;
  switch (toolType) {
    case ToolTypes.THP:
    case ToolTypes.SDP:
      icon = thpIcon;
      break;
    case ToolTypes.ANALOG_4_CH:
      icon = analogIcon;
    case ToolTypes.THERMO_4_CH:
      icon = therm4Icon;
      break;
    case ToolTypes.SWIM:
      icon = swimIcon;
      break;
    case ToolTypes.CHEM:
      icon = chemIcon;
      break;
    default:
      break;
  }
  const [open, setOpen] = useState(false);

  let ts = new Date(message.ts * 1000);

  let details = (
    <View
      style={{
        marginLeft: styles.itemIcon.width + Spacing.sm,
        borderTopWidth: 1,
        borderColor: Colors.light,
        paddingRight: Spacing.sm,
        paddingBottom: Spacing.sm,
        ...Helpers.rowCross,
        justifyContent: "space-between",
      }}
    >
      <View>
        {tool ? (
          <View style={{ ...Helpers.row, paddingTop: Spacing.sm }}>
            <Icon
              style={[Metrics.tinyHorizontalMargin, { marginTop: Spacing.xm }]}
              color={Colors.lightGrey}
              svg={toolSmallIcon}
              size="xs"
            />
            <Text style={{ flexShrink: 1 }} as="small" color="lightGrey">
              {" " + tool.settings.toolName}
            </Text>
          </View>
        ) : (
          <></>
        )}
        {message.msgType == "alert" ? (
          <View style={{ ...Helpers.row, paddingTop: Spacing.sm }}>
            <Icon
              style={[Metrics.tinyHorizontalMargin, { marginTop: Spacing.xm }]}
              color={Colors.lightGrey}
              svg={alertIcon}
              size="xs"
            />
            <Text style={{ flexShrink: 1 }} as="small" color="lightGrey">
              {" Some alert"}
            </Text>
          </View>
        ) : (
          <></>
        )}
        <View style={{ ...Helpers.row, paddingTop: Spacing.sm }}>
          <Icon
            style={[Metrics.tinyHorizontalMargin, { marginTop: Spacing.xm }]}
            color={Colors.lightGrey}
            svg={messageIcon}
            size="xs"
          />
          <Text style={{ flexShrink: 1 }} as="small" color="lightGrey">
            {_.has(message, "message")
              ? " " + message.message.body
              : " No msg attribute"}
          </Text>
        </View>
      </View>
      {tool ? (
        <View
          style={{ display: "flex", width: 90, justifyContent: "flex-end" }}
        >
          <Button
            style={{ width: 90, ...Metrics.verticalMargin }}
            text="Go to Tool"
            variant="primary"
            onPress={() => {
              let key = tool.mac ? tool.mac : tool.share_id;
              navigate(`/site/${key}`);
            }}
          />
        </View>
      ) : (
        <></>
      )}
    </View>
  );

  const component = (
    <View
      style={[
        styles.lightRow,
        { backgroundColor: Colors.white, cursor: "pointer" },
        Helpers.column,
      ]}
    >
      <View
        {...rest}
        style={[styles.item, style, { flex: 1 }]}
        padding="sm"
        sidePadding="md"
        gutter="none"
      >
        <View
          onClick={(e) => e.stopPropagation()}
          style={{ ...styles.symbolContainerLargeMargin, marginRight: 0 }}
        >
          <Checkbox
            onChange={(e) => {
              e.stopPropagation();
              let multiple = e.nativeEvent.shiftKey;
              // if(selected.includes(message.message_id)){
              //   removeSelected(message.message_id)
              // }else{
              //   addSelected(message.message_id)
              // }
              if (selected.includes(message.message_id)) {
                if (multiple && lastSelected) {
                  let currentIndex = _.findIndex(
                    messages,
                    (a) => a.message_id == message.message_id
                  );
                  let lastIndex = _.findIndex(
                    messages,
                    (a) => a.message_id == lastSelected
                  );
                  let lowIndex = Math.min(lastIndex, currentIndex);
                  let highIndex = Math.max(lastIndex, currentIndex);
                  messages.forEach((item, index) => {
                    if (
                      index >= lowIndex &&
                      index <= highIndex &&
                      index != currentIndex &&
                      selected.includes(item.message_id)
                    ) {
                      removeSelected(item.message_id);
                    }
                  });
                }
                removeSelected(message.message_id);
              } else {
                if (multiple && lastSelected) {
                  let currentIndex = _.findIndex(
                    messages,
                    (a) => a.message_id == message.message_id
                  );
                  let lastIndex = _.findIndex(
                    messages,
                    (a) => a.message_id == lastSelected
                  );
                  let lowIndex = Math.min(lastIndex, currentIndex);
                  let highIndex = Math.max(lastIndex, currentIndex);
                  messages.forEach((item, index) => {
                    if (
                      index >= lowIndex &&
                      index <= highIndex &&
                      index != currentIndex &&
                      !selected.includes(item.message_id)
                    ) {
                      addSelected(item.message_id);
                    }
                  });
                }
                addSelected(message.message_id);
              }
            }}
            onClick={(e) => e.stopPropagation()}
            checked={selected.includes(message.message_id)}
            style={{
              width: 32,
              height: 32,
            }}
          />
        </View>
        <View style={styles.itemIcon}>
          <Icon color={Colors.secondary} svg={icon} size="md" />
        </View>
        <View style={[styles.toolTitle, Helpers.column]}>
          <Text
            as="medium"
            color="black"
            weight={message.settings.read ? "medium" : "bold"}
          >
            {message.message.title}
          </Text>
          <View style={Helpers.rowCross}>
            {ts != undefined ? (
              <View style={Helpers.rowCross}>
                <Text as="small" color="lightGrey">
                  {HelperService.formatDate(ts, 0)}
                </Text>
                <Text as="small" color="lightGrey">
                  {" " + HelperService.formatTime(ts, 0) + " "}
                </Text>
                <Icon
                  style={Metrics.smallHorizontalPadding}
                  color={Colors.lightGrey}
                  svg={dot}
                  size="xxxs"
                />
                <Text as="small" color="lightGrey">
                  {" "}
                </Text>
              </View>
            ) : (
              <></>
            )}
            <Text as="small" color="lightGrey">
              {message.msgType}
            </Text>
          </View>
        </View>
        <View style={Helpers.rowCross}>
          {open ? (
            <View
              style={{ ...Metrics.smallHorizontalMargin }}
              onPress={() => setOpen(false)}
            >
              <Icon color={Colors.lightGrey} svg={arrowDown} size="s10" />
            </View>
          ) : (
            <View
              style={{ ...Metrics.smallHorizontalMargin }}
              onPress={() => setOpen(true)}
            >
              <Icon color={Colors.lightGrey} svg={arrowUp} size="s10" />
            </View>
          )}
        </View>
        {children}
      </View>
      {open ? details : <></>}
    </View>
  );

  return (
    <View
      onClick={(e) => {
        e.stopPropagation();
        if (open) {
          setOpen(false);
        } else {
          if (!message.settings.read) {
            updateMessage(message.message_id, { read: true }).then((result) => {
              console.log("Update Message Result:", result);
              if (result == true) updateCallback();
            });
          }
          setOpen(true);
        }
      }}
    >
      {component}
    </View>
  );
};

Row.Alert = ({
  style,
  children,
  alert,
  channel,
  addSelected,
  removeSelected,
  selected,
  selectMode,
  currentAlertId,
  onPress,
  alerts,
  lastSelected,
  updateAlerts,
  ...rest
}) => {
  const [enabled, setEnabled] = useState(alert.settings.alertEnable);
  async function updateEnabled(enabled) {
    setEnabled(enabled);
    await updateAlert(
      alert.mac ? { mac: alert.mac } : { share_id: alert.share_id },
      alert.alert_id,
      { alertEnable: enabled }
    );
    updateAlerts();
  }

  let testCondition;
  switch (alert.settings.testCondition) {
    case "GT":
      testCondition = ">";
      break;
    case "LS":
      testCondition = "<";
      break;
    default:
      testCondition = "";
      break;
  }

  let alertLength = alert.alertState.alertCnt;
  let alertLengthString = alertLength.toFixed(0);
  if (alertLengthString.length >= 6) alertLengthString = "99999+"; // alertLengthString = "888"
  let unit = _.get(channel, "linearScalingEnable")
    ? _.get(channel, "linearScalingUnit")
    : _.get(channel, "unit");
  let alertLeftOffeset = 20;
  if (alertLengthString.length >= 3) {
    alertLeftOffeset = alertLeftOffeset - 12 * (alertLengthString.length - 2);
  }

  const component = (
    <View
      style={[
        styles.lightRow,
        {
          backgroundColor:
            currentAlertId == alert.alert_id
              ? Colors.secondary20
              : Colors.white,
        },
        Helpers.column,
      ]}
    >
      <View
        {...rest}
        style={[styles.item, style, { flex: 1, position: "relative" }]}
        sidePadding="md"
        gutter="none"
      >
        {alertLength > 0 && (
          <View
            style={[
              styles.alertNotificationText,
              {
                position: "absolute",
                left: 95.5,
                top: 4.5,
                width:
                  alertLengthString.length > 1
                    ? 20 + 7 * (alertLengthString.length - 1)
                    : 20,
              },
            ]}
          >
            <Text as="small" color="white">
              {alertLengthString}
            </Text>
          </View>
        )}
        {alertLength > 0 && (
          <View
            style={[
              styles.alertNotification,
              {
                position: "absolute",
                left: 95,
                top: 7,
                width:
                  alertLengthString.length > 1
                    ? 20 + 7 * (alertLengthString.length - 1)
                    : 20,
              },
            ]}
          ></View>
        )}
        <View
          onClick={(e) => e.stopPropagation()}
          style={{ ...styles.symbolContainerLargeMargin, marginRight: 0 }}
        >
          <Checkbox
            onChange={(e) => {
              e.stopPropagation();
              let multiple = e.nativeEvent.shiftKey;
              if (selected.includes(alert.alert_id)) {
                if (multiple && lastSelected) {
                  let currentIndex = _.findIndex(
                    alerts,
                    (a) => a.alert_id == alert.alert_id
                  );
                  let lastIndex = _.findIndex(
                    alerts,
                    (a) => a.alert_id == lastSelected
                  );
                  let lowIndex = Math.min(lastIndex, currentIndex);
                  let highIndex = Math.max(lastIndex, currentIndex);
                  alerts.forEach((item, index) => {
                    if (
                      index >= lowIndex &&
                      index <= highIndex &&
                      index != currentIndex &&
                      selected.includes(item.alert_id)
                    ) {
                      removeSelected(item.alert_id);
                    }
                  });
                }
                removeSelected(alert.alert_id);
              } else {
                if (multiple && lastSelected) {
                  let currentIndex = _.findIndex(
                    alerts,
                    (a) => a.alert_id == alert.alert_id
                  );
                  let lastIndex = _.findIndex(
                    alerts,
                    (a) => a.alert_id == lastSelected
                  );
                  let lowIndex = Math.min(lastIndex, currentIndex);
                  let highIndex = Math.max(lastIndex, currentIndex);
                  alerts.forEach((item, index) => {
                    if (
                      index >= lowIndex &&
                      index <= highIndex &&
                      index != currentIndex &&
                      !selected.includes(item.alert_id)
                    ) {
                      addSelected(item.alert_id);
                    }
                  });
                }
                addSelected(alert.alert_id);
              }
            }}
            onClick={(e) => e.stopPropagation()}
            checked={selected.includes(alert.alert_id)}
            style={{
              width: 32,
              height: 32,
            }}
          />
        </View>
        <View style={{ ...styles.symbolContainerLargeMargin }}>
          <div
            style={{
              height: Spacing.compWidth,
              width: "100%",
              ...Helpers.center,
              overflow: "clip",
              position: "relative",
            }}
          >
            <Icon
              color={Colors.vlightGrey}
              svg={
                alert.alertMode == "offlineMode"
                  ? networkLossIcon
                  : alert.alertMode == "powerDisconnectMode"
                  ? powerLossIcon
                  : alert.alertMode == "sensorMode" && testCondition == ">"
                  ? greaterThanIcon
                  : alert.alertMode == "sensorMode" && testCondition == "<"
                  ? lessThanIcon
                  : alertBigIcon
              }
              size="md"
            />
          </div>
        </View>
        <View style={[styles.toolTitle, Helpers.column]}>
          <Text as="medium" color="black" weight="bold">
            {alert.settings.alertName}
          </Text>
          <View style={Helpers.rowCross}>
            {alert.alertMode == "sensorMode" ? (
              <View style={Helpers.rowCross}>
                <Text as="small" color="lightGrey">
                  {_.get(channel, "name") + " "}
                </Text>
                <Icon
                  style={{ alignSelf: "center" }}
                  color={Colors.lightGrey}
                  svg={dot}
                  size="xxxs"
                />
                <Text as="small" color="lightGrey">
                  {" "}
                </Text>
                <Text as="small" color="lightGrey">
                  {testCondition}
                </Text>
                <Text as="small" color="lightGrey">
                  {alert.settings.testValue + " " + unit + " "}
                </Text>
                <Icon
                  style={{ alignSelf: "center" }}
                  color={Colors.lightGrey}
                  svg={dot}
                  size="xxxs"
                />
                <Text as="small" color="lightGrey">
                  {" "}
                </Text>
              </View>
            ) : (
              <></>
            )}

            <Icon color={Colors.lightGrey} svg={alertIcon} size="xs" />
          </View>
        </View>
        <View
          style={Helpers.rowCross}
          onClick={(event) => event.stopPropagation()}
        >
          <Switch
            style={{ colorPrimary: Colors.primary }}
            checked={enabled}
            onChange={updateEnabled}
          />
        </View>
        {children}
      </View>
    </View>
  );

  return (
    <View
      style={{ cursor: "pointer" }}
      onClick={(event) => {
        event.stopPropagation();
        onPress();
      }}
    >
      {component}
    </View>
  );
};

Row.AlertNotification = ({ style, children, event, ...rest }) => {
  let ts = new Date(event.ts * 1000);

  const component = (
    <View
      {...rest}
      style={[
        styles.item,
        styles.lightRow,
        style,
        { backgroundColor: Colors.white, minHeight: Spacing.xxl },
      ]}
      sidePadding="md"
      gutter="none"
    >
      <View style={styles.symbolContainerLargeMargin}>
        <Icon color={Colors.lightGrey} svg={alertIcon} size="xs" />
      </View>
      <View style={[styles.toolTitle, Helpers.column]}>
        <View style={Helpers.rowCross}>
          <View style={{ ...Helpers.rowCross }}>
            {ts != undefined ? (
              <View style={Helpers.row}>
                <Text as="small" color="darkGrey">
                  {HelperService.formatDate(ts, 0)}
                </Text>
                <Text as="small" color="darkGrey">
                  {" " + HelperService.formatTime(ts, 0) + " "}
                </Text>
                <View style={Helpers.rowCross}>
                  <Icon
                    style={{ display: "flex", alignSelf: "center" }}
                    color={Colors.darkGrey}
                    svg={dot}
                    size="xxxs"
                  />
                </View>
                <Text as="small" color="darkGrey">
                  {" "}
                </Text>
              </View>
            ) : (
              <></>
            )}
            <Text as="small" color="darkGrey">
              {"Alert "}
            </Text>
            <Text as="small" color="darkGrey">
              {event.state}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );

  return component;
};

Row.AlertSummary = ({ style, children, alert, tool, onPress, ...rest }) => {
  // const dispatch = useDispatch()
  let channel = _.get(tool.settings.channels, alert.settings.testField);
  const [enabled, setEnabled] = useState(alert.settings.alertEnable);
  useEffect(() => {
    setEnabled(alert?.settings?.alertEnable);
  }, [alert.settings.alertEnable]);
  function updateEnabled(enabled) {
    setEnabled(enabled);
    updateAlert(
      alert.mac ? { mac: alert.mac } : { share_id: alert.share_id },
      alert.alert_id,
      { alertEnable: enabled }
    );
  }

  const component = (
    <View
      style={{
        paddingRight: Spacing.sm,
        paddingBottom: Spacing.sm,
        ...Helpers.column,
      }}
      sidePadding="md"
    >
      <View style={{ ...Helpers.row, paddingTop: Spacing.sm }}>
        <View style={styles.symbolContainerLargeMargin}>
          <Icon
            style={[{ marginTop: Spacing.xm }]}
            color={Colors.lightGrey}
            svg={toolSmallIcon}
            size="xs"
          />
        </View>
        <Text style={{ flexShrink: 1 }} as="small" color="lightGrey">
          {alert.settings.alertName}
        </Text>
        <View
          style={{
            ...Helpers.row,
            flex: 1,
            justifyContent: "flex-end",
            cursor: "pointer",
          }}
          onClick={onPress}
        >
          <Text style={{ flexShrink: 1 }} as="small" color="lightGrey">
            {"Edit  "}
          </Text>
          <Icon
            style={{ alignSelf: "center" }}
            color={Colors.lightGrey}
            svg={arrowRightIcon}
            size="xs"
          />
        </View>
      </View>
      {alert.alertMode == "sensorMode" ? (
        <View style={{ ...Helpers.row, paddingTop: Spacing.sm }}>
          <View style={styles.symbolContainerLargeMargin}>
            <Icon
              style={[{ marginTop: Spacing.xm }]}
              color={Colors.lightGrey}
              svg={channelIcon}
              size="xs"
            />
          </View>
          <View
            style={{
              ...Helpers.row,
              flex: 1,
              justifyContent: "space-between",
              alignItems: "flex-start",
              paddingTop: Spacing.sm,
            }}
          >
            <Text as="small" color="lightGrey">
              {_.get(channel, "name")}
            </Text>
          </View>
        </View>
      ) : (
        <></>
      )}
      {alert.alertMode == "sensorMode" ? (
        <View style={{ ...Helpers.row, paddingTop: Spacing.sm }}>
          <View style={styles.symbolContainerLargeMargin}>
            <Icon
              style={[{ marginTop: Spacing.xm }]}
              color={Colors.lightGrey}
              svg={alertIcon}
              size="xs"
            />
          </View>
          <Text as="small" color="lightGrey">
            {alert.settings.testCondition == "GT" ? "Greater" : "Less"}
          </Text>
          <Text as="small" color="lightGrey">
            {" than " + alert.settings.testValue + " " + _.get(channel, "unit")}
          </Text>
        </View>
      ) : (
        <></>
      )}
    </View>
  );

  return component;
};

Row.SettingLink = ({
  style,
  title,
  label,
  state,
  stateValue,
  onPress,
  noBorder,
  children,
  symbol,
  color,
  symbolSize,
  noArrow,
  colorAll,
  value,
  toolValue,
  syncTime,
  tool,
  getSettings,
  ...rest
}) => {
  // const dispatch = useDispatch()
  const [syncPending, setSyncPending] = useState(false);
  let usbPowered =
    _.has(tool, "toolSystem") && !_.isEmpty(tool.toolSystem)
      ? tool.toolSystem.sysPowerState == "USB"
      : undefined;
  let time =
    tool && _.has(tool, "nextUpdateTS")
      ? new Date(tool.nextUpdateTS * 1000)
      : null;

  const component = (
    <View
      style={
        noBorder
          ? [style]
          : [styles.lightRow, { flexDirection: "column" }, style]
      }
      gutter="none"
      sidePadding="md"
    >
      <View {...rest} style={[styles.item, { flex: 1 }]}>
        {symbol && colorAll ? (
          <View style={styles.itemIcon}>
            <Icon
              svg={symbol}
              size={symbolSize ? symbolSize : "xs"}
              color={colorAll}
            />
          </View>
        ) : symbol && color ? (
          <View style={styles.itemIcon}>
            <Icon
              svg={symbol}
              size={symbolSize ? symbolSize : "xs"}
              color={color}
            />
          </View>
        ) : symbol ? (
          <View style={styles.itemIcon}>
            <Icon svg={symbol} size={symbolSize ? symbolSize : "xs"} />
          </View>
        ) : (
          <></>
        )}
        <View
          style={[
            styles.toolTitle,
            {
              justifyContent: "flex-start",
              alignItems: "center",
              overflow: "hidden",
              whiteSpace: "nowrap",
            },
          ]}
        >
          <Text
            style={{
              width: "100%",
              color: colorAll ? colorAll : Colors.darkGrey,
            }}
            as="medium"
          >
            {title}
          </Text>
        </View>
        {onPress && (
          <View style={Helpers.center}>
            <View style={[styles.rightText, Helpers.rowCross]}>
              {toolValue != undefined &&
              toolValue != null &&
              value != toolValue &&
              (syncTime || !usbPowered) &&
              usbPowered != undefined ? (
                <View
                  style={[styles.itemIcon, { cursor: "pointer" }]}
                  onClick={() => {
                    setSyncPending(true);
                  }}
                >
                  <Icon svg={syncPendingIcon} size="s18" />
                </View>
              ) : (
                <></>
              )}
              {label ? (
                <Text
                  as="small"
                  style={{ paddingRight: 12 }}
                  color={"darkGrey"}
                >
                  {label}
                </Text>
              ) : (
                <></>
              )}
              {state ? (
                <Text
                  as="small"
                  style={{ paddingRight: 12 }}
                  color={stateValue ? "positive" : "error"}
                >
                  {stateValue ? "Enabled" : "Disabled"}
                </Text>
              ) : (
                <></>
              )}
              {noArrow ? (
                <></>
              ) : (
                <Icon
                  color={colorAll ? colorAll : Colors.lightGrey}
                  svg={arrowIcon}
                  size="xs"
                />
              )}
            </View>
          </View>
        )}
      </View>
      {children}
      <Alert
        visible={syncPending}
        setVisible={setSyncPending}
        title="Sync to Tool Pending"
        text={
          "Modified preferences have not been synced to your Tool." +
          (usbPowered
            ? " Check your Tool's power and internet connection."
            : " Press the button on your Tool to sync immediatedly.")
        }
        oneButton={true}
        onPress={async () => {
          await getSettings(tool);
          setSyncPending(false);
        }}
      >
        {toolValue != undefined &&
        toolValue != null &&
        value != toolValue &&
        !usbPowered &&
        usbPowered != undefined ? (
          <View style={[Helpers.row, { marginTop: Spacing.sm }]} gutter="none">
            <View
              style={[
                styles.symbolContainer,
                { marginLeft: 0, marginRight: 0 },
              ]}
            >
              <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
            </View>
            <View>
              <Text color="lightGrey" as="small">
                {" Synchronization scheduled at " +
                  HelperService.formatTime(time, 0)}
              </Text>
            </View>
          </View>
        ) : (
          <></>
        )}
      </Alert>
    </View>
  );

  if (onPress) {
    return (
      <View style={{ cursor: "pointer" }} onClick={onPress}>
        {component}
      </View>
    );
  }
  return component;
};

Row.WiFi = ({ style, title, first, rssi, onPress, children, ...rest }) => {
  const sectionPadding = first ? { paddingTop: 16 } : { paddingTop: 32 };
  let icon = wifiIcon;
  // if(rssi>-50){
  //   icon = arrowIcon
  // }
  const component = (
    <View
      {...rest}
      style={[styles.lightRow, styles.item, { ...sectionPadding }, style]}
      padding="md"
      gutter="none"
      sidePadding="md"
    >
      <View style={[styles.itemIcon, { paddingRight: Spacing.md }]}>
        <Icon svg={icon} size="sm" />
      </View>
      <View style={[styles.toolTitle]}>
        <Text as="small" color="darkGrey" weight="bold">
          {title}
        </Text>
      </View>
      {onPress && (
        <View style={[styles.rightIcon]}>
          <Icon color={Colors.lightGrey} svg={arrowIcon} size="xs" />
        </View>
      )}

      {children}
    </View>
  );

  if (onPress) {
    return <View onClick={onPress}>{component}</View>;
  }
  return component;
};

Row.StratusWiFi = ({
  style,
  title,
  first,
  rssi,
  value,
  onValueChange,
  ...rest
}) => {
  const sectionPadding = first ? { paddingTop: 16 } : { paddingTop: 32 };
  let icon = toolIcon;
  // if(rssi>-50){
  //   icon = arrowIcon
  // }
  const component = (
    <View
      onPress={() => {
        onValueChange(!value);
      }}
      {...rest}
    >
      <View
        style={[styles.lightRow, styles.item, { ...sectionPadding }, style]}
        padding="sm"
        gutter="none"
        sidePadding="md"
      >
        <View style={[styles.itemIcon, { paddingRight: Spacing.md }]}>
          <Icon svg={icon} size="sm" />
        </View>
        <View style={[styles.toolTitle]}>
          <Text as="small" color="darkGrey" weight="bold">
            {title}
          </Text>
        </View>
        <View
          style={[styles.rightIcon]}
          onPress={() => {
            onValueChange(!value);
          }}
        >
          <Checkbox
            tintColors={{ true: Colors.primary, false: Colors.primary }}
            boxType="square"
            tintColor={Colors.primary}
            onTintColor={Colors.primary}
            onFillColor={Colors.primary}
            onCheckColor={Colors.white}
            disabled={false}
            value={value}
            onValueChange={onValueChange}
            style={{
              width: 16,
              height: 16,
              paddingLeft: 0,
              marginRight: 8,
              marginVertical: 8,
            }}
          />
        </View>
      </View>
      {/* {onPress && (
        <View style={[styles.rightIcon]}>
          <Icon color={Colors.lightGrey} svg={arrowIcon} size="xs" />
        </View>
      )} */}

      {/* {children} */}
    </View>
  );

  // if (onPress) {
  //   return <View onPress={onPress}>{component}</View>
  // }
  return component;
};

Row.Dropdown = ({
  style,
  title,
  value,
  setValue,
  onPress,
  children,
  ...rest
}) => {
  const [options, setOptions] = useState([]);
  const [cascaderValue, setCascaderValue] = useState([]);
  useEffect(() => {
    console.log("Dropdown VALUE:", value);
    let tempOptions = [];
    let tempCascaderValue = [];
    Object.keys(value).forEach((element) => {
      let label = element;
      if (label == "reportMonthly") {
        label = "Monthly";
      } else if (label == "reportWeekly") {
        label = "Weekly";
      } else if (label == "reportDaily") {
        label = "Daily";
      }
      tempOptions.push({ label: label, value: element });
      if (value[element]) {
        ``;
        tempCascaderValue.push([element]);
      }
    });
    console.log("Dropdown tempOptions:", tempOptions);
    console.log("Dropdown tempCascaderValue:", tempCascaderValue);
    setCascaderValue(tempCascaderValue);
    setOptions(tempOptions);
  }, [value]);

  const onChange = (newValue) => {
    console.log(newValue);
    setCascaderValue(newValue);
    let tempValue = _.cloneDeep(value);
    Object.keys(tempValue).forEach((key) => {
      tempValue[key] = false;
    });
    newValue.forEach((element) => {
      tempValue[element[0]] = true;
    });
    setValue(tempValue);
  };

  return (
    <>
      <View sidePadding="md">
        {title ? (
          <Text as="md" color="textPrimary" weight="medium">
            {title}
          </Text>
        ) : (
          <></>
        )}
        <Cascader
          style={{
            width: "100%",
          }}
          options={options}
          onChange={onChange}
          value={cascaderValue}
          multiple
          maxTagCount="responsive"
        />
      </View>
    </>
  );
};

// Children on all rows below are for activated elements based on an action, example picker display
Row.Setting = ({
  style,
  type,
  icon,
  color,
  title,
  numeric,
  setting,
  setSetting,
  changeSetting,
  onPress,
  children,
  noBorder,
  unit,
  min,
  max,
  placeholder,
  ...rest
}) => {
  var myTextInput = null;
  const [address, setAddress] = useState("");

  const onCheckLimit = (value) => {
    const parsedQty = value === "" ? undefined : Number(value);
    if (isNaN(parsedQty)) {
    } else if (parsedQty > max) {
      changeSetting(max.toLocaleString());
    } else if (parsedQty < min) {
      changeSetting(min.toLocaleString());
    } else {
      changeSetting(value);
    }
  };

  const handleSelect = (selectedAddress) => {
    setAddress(selectedAddress);
    changeSetting(selectedAddress);
  };

  const component = (
    <View
      {...rest}
      style={
        noBorder
          ? [styles.item, Helpers.column]
          : [styles.lightRow, styles.item, Helpers.column]
      }
      onPress={() => myTextInput.focus()}
      sidePadding="md"
    >
      <View style={[styles.item, style]} gutter="none">
        {icon && color ? (
          <View style={styles.itemIcon}>
            <Icon svg={icon} size="xs" color={color} />
          </View>
        ) : icon ? (
          <View style={styles.itemIcon}>
            <Icon svg={icon} size="xs" />
          </View>
        ) : (
          <></>
        )}
        <View style={{ ...Helpers.column, flex: 1, justifyContent: "center" }}>
          <View>
            {title ? (
              <Text as="md" color="textPrimary" weight="medium">
                {title}
              </Text>
            ) : (
              <></>
            )}
            <Space.Compact style={Helpers.row}>
              {/* {type === 'address' ? (
                <PlacesAutocomplete
                  apiKey={process.env.REACT_APP_GOOGLE}
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                />
              ) : ( */}
              <Input
                styles={{ prefix: " " }}
                ref={(o) => (myTextInput = o)}
                autoCapitalize="none"
                style={{
                  textAlign: "left",
                  color: Colors.darkGrey,
                  paddingLeft: 10,
                  ...Fonts.medium,
                  fontFamily: "Inter-Regular",
                  flex: 1,
                }} //medium
                selectionColor={Colors.highlight}
                value={setting}
                onChangeText={
                  min && max
                    ? (setting) => onCheckLimit(setting)
                    : (setting) => changeSetting(setting)
                }
                onChange={
                  min && max
                    ? (event) => onCheckLimit(event.target.value)
                    : (event) => changeSetting(event.target.value)
                }
                keyboardType={numeric ? "numeric" : "default"}
                onEndEditing={setSetting ? setSetting : null}
                selectTextOnFocus={true}
                returnKeyType="done"
                onBlur={setSetting ? setSetting : null}
                placeholder={placeholder}
              />
              {/* )} */}
              {unit ? (
                <Text
                  style={{
                    alignSelf: "center",
                    ...Metrics.smallHorizontalMargin,
                  }}
                  as="medium"
                  color="darkGrey"
                >
                  {unit}
                </Text>
              ) : (
                <></>
              )}
            </Space.Compact>
          </View>
          {children}
        </View>
      </View>
    </View>
  );

  if (onPress) {
    return <View onPress={onPress}>{component}</View>;
  }
  return component;
};

Row.List = ({
  style,
  icon,
  title,
  values,
  displayValue,
  selectedValues,
  onPress,
  onSelect,
  listVisible,
  multiple,
  ...rest
}) => {
  const component = (
    <View style={styles.row}>
      <View onPress={onPress}>
        <View {...rest} style={[styles.item, style]} padding="md" gutter="none">
          {icon && (
            <View style={styles.itemIcon}>
              <Icon svg={icon} size="sm" />
            </View>
          )}
          <View style={styles.itemTitle}>
            <Text as="small">{title}</Text>
          </View>
          <View style={styles.itemValue}>
            <Text as="small" color="dark">
              {displayValue}
            </Text>
          </View>
          {onPress && (
            <View style={styles.itemArrow}>
              <Icon
                color={Colors.light}
                svg={listVisible ? openIcon : disclosureIcon}
                size="xs"
              />
            </View>
          )}
        </View>
      </View>
      {listVisible && (
        <View style={[styles.item, { marginBottom: 16 }]}>
          <View style={{ flex: 1, marginHorizontal: 8 }}>
            {values.map((item, index) => {
              let selected = multiple && selectedValues.includes(item.id);
              return (
                <View key={item.id} onPress={() => onSelect(item)}>
                  <View
                    style={[
                      styles.item,
                      {
                        paddingVertical: 8,
                        borderBottomWidth: index === values.length - 1 ? 0 : 1,
                        borderColor: Colors.dark,
                      },
                    ]}
                  >
                    <View style={styles.itemTitle}>
                      <Text>{item.name}</Text>
                    </View>
                    <View style={styles.itemArrow}>
                      {selected && (
                        <Icon color={Colors.light} svg={checkIcon} size="xs" />
                      )}
                    </View>
                  </View>
                </View>
              );
            })}
          </View>
        </View>
      )}
    </View>
  );

  return component;
};
Row.PageTitle = ({ title, left, right, right2, right3, right4, minHeight }) => {
  return (
    <View
      style={[
        styles.item,
        {
          flex: 1,
          paddingBottom: title == "" ? 53 : minHeight ? 0 : 17,
          paddingTop: minHeight ? 0 : 17,
          marginLeft: Spacing.md,
          minHeight: minHeight ? 0 : Spacing.compWidth,
        },
        Helpers.rowCross,
      ]}
    >
      {left && (
        <View
          style={{ cursor: "pointer", marginRight: Spacing.md }}
          onClick={left.onPress}
        >
          <Icon svg={left.icon} color={Colors.darkGrey} size="sm" />
        </View>
      )}
      <Text
        style={{ width: "100%", color: Colors.darkGrey }}
        as="xxlarge"
        weight="bold"
      >
        {title}
      </Text>
      {right && (
        <View
          style={{
            cursor:
              "disabled" in right && right.disabled == true
                ? "default"
                : "pointer",
            marginRight: Spacing.md,
            marginLeft: Spacing.md,
          }}
          onClick={
            "disabled" in right && right.disabled == true ? null : right.onPress
          }
        >
          <Icon
            svg={right.icon}
            color={
              "disabled" in right && right.disabled == true
                ? Colors.darkGrey30
                : Colors.darkGrey
            }
            size="sm"
          />
        </View>
      )}
      {right2 && (
        <View
          style={{
            cursor:
              "disabled" in right2 && right2.disabled == true
                ? "default"
                : "pointer",
            marginRight: Spacing.md,
            marginLeft: Spacing.md,
          }}
          onClick={
            "disabled" in right2 && right2.disabled == true
              ? null
              : right2.onPress
          }
        >
          <Icon
            svg={right2.icon}
            color={
              "disabled" in right2 && right2.disabled == true
                ? Colors.darkGrey30
                : Colors.darkGrey
            }
            size="sm"
          />
        </View>
      )}
      {right3 && (
        <View
          style={{
            cursor:
              "disabled" in right3 && right3.disabled == true
                ? "default"
                : "pointer",
            marginRight: Spacing.md,
            marginLeft: Spacing.md,
          }}
          onClick={
            "disabled" in right3 && right3.disabled == true
              ? null
              : right3.onPress
          }
        >
          <Icon
            svg={right3.icon}
            color={
              "disabled" in right3 && right3.disabled == true
                ? Colors.darkGrey30
                : Colors.darkGrey
            }
            size="sm"
          />
        </View>
      )}
      {right4 && (
        <View
          style={{
            cursor:
              "disabled" in right4 && right4.disabled == true
                ? "default"
                : "pointer",
            marginRight: Spacing.md,
            marginLeft: Spacing.md,
          }}
          onClick={
            "disabled" in right4 && right4.disabled == true
              ? null
              : right4.onPress
          }
        >
          <Icon
            svg={right4.icon}
            color={
              "disabled" in right4 && right4.disabled == true
                ? Colors.darkGrey30
                : Colors.darkGrey
            }
            size="sm"
          />
        </View>
      )}
    </View>
  );
};
Row.Time = ({
  style,
  icon,
  title,
  value,
  onPressTime,
  onPressDate,
  onChangeDate,
  onChangeTime,
  timePickerVisible,
  datePickerVisible,
  min,
  max,
  ...rest
}) => {
  console.log("TIME VALUE:", value);
  const component = (
    <View>
      <View
        {...rest}
        style={[styles.lightRow, styles.item, style]}
        padding="md"
        gutter="none"
        sidePadding="md"
      >
        {icon && (
          <View style={styles.itemIcon}>
            <Icon svg={icon} size="xs" />
          </View>
        )}
        <View style={styles.itemTitle}>
          <Text as="medium" color="darkGrey">
            {title}
          </Text>
        </View>
        <View style={{ flex: 1 }} onPress={onPressDate}>
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <DatePicker
              textColor={Colors.light}
              style={{ flex: 1 }}
              testID="startDatePicker"
              value={dayjs(value)}
              // defaultValue={dayjs(value)}
              is24Hour={false}
              display="default"
              onChange={onChangeDate}
              minimumDate={min ? min : null}
              maximumDate={max ? max : null}
            />
          </View>
        </View>
        <View style={{ flex: 1 }} onPress={onPressTime}>
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <TimePicker
              textColor={Colors.light}
              style={{ flex: 1 }}
              testID="startTimePicker"
              value={dayjs(value)}
              // defaultValue={dayjs(value)}
              use12Hours
              format="h:mm a"
              is24Hour={false}
              display="default"
              onChange={onChangeTime}
            />
          </View>
        </View>
        {/* {onPress && (
            <View style={[styles.itemArrow,{backgroundColor:"orange"} ]}>
              <Icon
                color={Colors.light}
                svg={pickerVisible ? openIcon : disclosureIcon}
                color={Colors.light}
                size="xs"
              />
            </View>
          )} */}
      </View>
    </View>
  );

  return component;
};

Row.Button = ({ style, icon, title, desc, onPress, children, ...rest }) => (
  <View onPress={onPress}>
    <View
      {...rest}
      style={[styles.row, styles.item, Metrics.smallBottomMargin, style]}
      padding="md"
      gutter="none"
    >
      {icon && (
        <View style={styles.itemIcon}>
          <Icon svg={icon} size="sm" />
        </View>
      )}
      <View style={styles.itemTitle}>
        <Text>{title}</Text>

        <Text as="small" color="dark">
          {desc}
        </Text>
      </View>
      {children}
    </View>
  </View>
);

Row.Segment = ({
  style,
  icon,
  title,
  values,
  selectedIndex,
  onTabPress,
  children,
  ...rest
}) => (
  <View
    {...rest}
    style={[styles.row, styles.item, Metrics.smallBottomMargin, style]}
    padding="md"
    gutter="none"
  >
    {icon && (
      <View style={styles.itemIcon}>
        <Icon svg={icon} size="sm" />
      </View>
    )}
    <View style={styles.itemTitle}>
      <Text>{title}</Text>
    </View>
    <View style={styles.itemValue}>
      <Segment
        values={values}
        selectedIndex={selectedIndex}
        onTabPress={onTabPress}
      />
    </View>
    {children}
  </View>
);

Row.Toggle = ({
  style,
  icon,
  color,
  title,
  value,
  onValueChange,
  toolValue,
  children,
  noBorder,
  syncTime,
  tool,
  getSettings,
  ...rest
}) => {
  // const dispatch = useDispatch()
  const [syncPending, setSyncPending] = useState(false);
  let usbPowered =
    _.has(tool, "toolSystem") && !_.isEmpty(tool.toolSystem)
      ? tool.toolSystem.sysPowerState == "USB"
      : undefined;
  let time =
    tool && _.has(tool, "nextUpdateTS")
      ? new Date(tool.nextUpdateTS * 1000)
      : null;
  return (
    <View
      {...rest}
      style={
        noBorder
          ? [style, Helpers.column]
          : [styles.lightRow, style, Helpers.column]
      }
      gutter="none"
      sidePadding="md"
    >
      <View {...rest} style={[styles.item, { alignItems: "center", flex: 1 }]}>
        {icon && color ? (
          <View style={styles.itemIcon}>
            <Icon svg={icon} size="xs" color={color} />
          </View>
        ) : icon ? (
          <View style={styles.itemIcon}>
            <Icon svg={icon} size="xs" />
          </View>
        ) : (
          <></>
        )}
        <View style={{ paddingRight: Spacing.sm, ...styles.itemTitle }}>
          <Text as="md" color="textPrimary" weight="medium">
            {title}
          </Text>
        </View>
        {toolValue != undefined &&
        toolValue != null &&
        value != toolValue &&
        (syncTime || !usbPowered) &&
        usbPowered != undefined ? (
          <View
            style={[styles.itemIcon, { cursor: "pointer" }]}
            onClick={() => {
              console.log("toolValue:", toolValue, "value:", value);
              setSyncPending(true);
            }}
          >
            <Icon svg={syncPendingIcon} size="s18" />
          </View>
        ) : (
          <></>
        )}

        <Switch
          style={{ colorPrimary: Colors.primary }}
          checked={value}
          // defaultChecked={value}
          onChange={onValueChange}
          // trackColor={{ false: Colors.vlightGrey, true: Colors.lightBlue }}
          // thumbColor={value? (Colors.primary):(Colors.lightGrey)}
          // ios_backgroundColor={Colors[700]}
        />
      </View>
      {children}
      <Alert
        visible={syncPending}
        setVisible={setSyncPending}
        title="Sync to Tool Pending"
        text={
          "Modified preferences have not been synced to your Tool." +
          (usbPowered
            ? " Check your Tool's power and internet connection."
            : " Press the button on your Tool to sync immediatedly.")
        }
        oneButton={true}
        onPress={async () => {
          await getSettings(tool);
          setSyncPending(false);
        }}
      >
        {toolValue != undefined &&
        toolValue != null &&
        value != toolValue &&
        !usbPowered &&
        usbPowered != undefined ? (
          <View style={[Helpers.row, { marginTop: Spacing.sm }]} gutter="none">
            <View
              style={[
                styles.symbolContainer,
                { marginLeft: 0, marginRight: 0 },
              ]}
            >
              <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
            </View>
            <View>
              <Text color="lightGrey" as="small">
                {" Synchronization scheduled at " +
                  HelperService.formatTime(time, 0)}
              </Text>
            </View>
          </View>
        ) : (
          <></>
        )}
      </Alert>
    </View>
  );
};

Row.TwoToggle = ({
  style,
  icon,
  color,
  title,
  value,
  onValueChange,
  children,
  option1,
  option2,
  toolValue,
  syncTime,
  tool,
  getSettings,
  ...rest
}) => {
  // const dispatch = useDispatch()
  const [syncPending, setSyncPending] = useState(false);
  let usbPowered =
    _.has(tool, "toolSystem") && !_.isEmpty(tool.toolSystem)
      ? tool.toolSystem.sysPowerState == "USB"
      : undefined;
  let time =
    tool && _.has(tool, "nextUpdateTS")
      ? new Date(tool.nextUpdateTS * 1000)
      : null;
  return (
    <View
      {...rest}
      style={[
        styles.lightRow,
        styles.item,
        { alignItems: "center", justifyContent: "center" },
        style,
      ]}
      gutter="none"
      sidePadding="md"
    >
      {icon && color ? (
        <View style={styles.itemIcon}>
          <Icon svg={icon} size="xs" color={color} />
        </View>
      ) : icon ? (
        <View style={styles.itemIcon}>
          <Icon svg={icon} size="xs" />
        </View>
      ) : (
        <></>
      )}
      {/* styles.itemTitle,weight={value==0?'bold':'medium'}marginRight:60, */}
      <View
        style={[
          { alignItems: "center", justifyContent: "center", ...Helpers.row },
        ]}
      >
        <Text as="medium" color="darkGrey">
          {title}
        </Text>
        {toolValue != undefined &&
        toolValue != null &&
        value != toolValue &&
        (syncTime || !usbPowered) &&
        usbPowered != undefined ? (
          <View
            style={[styles.itemIcon, { cursor: "pointer" }]}
            onClick={() => {
              setSyncPending(true);
            }}
          >
            <Icon svg={syncPendingIcon} size="s18" />
          </View>
        ) : (
          <View style={{ paddingRight: Spacing.xl }}></View>
        )}
      </View>
      <View
        style={{
          flex: 1,
          ...Helpers.row,
          height: 46,
          justifyContent: "center",
        }}
      >
        <View
          style={value == 0 ? styles.leftSelected : styles.leftUnselected}
          onClick={() => onValueChange(0)}
        >
          <Text
            style={{ cursor: "pointer" }}
            font="inter"
            as="small"
            color={value == 0 ? "white" : "lightGrey"}
          >
            {option1}
          </Text>
        </View>
        <View
          style={value == 1 ? styles.rightSelected : styles.rightUnselected}
          onClick={() => onValueChange(1)}
        >
          <Text
            style={{ cursor: "pointer" }}
            font="inter"
            as="small"
            color={value == 1 ? "white" : "lightGrey"}
          >
            {option2}
          </Text>
        </View>
      </View>
      {children}
      <Alert
        visible={syncPending}
        setVisible={setSyncPending}
        title="Sync to Tool Pending"
        text={
          "Modified preferences have not been synced to your Tool." +
          (usbPowered
            ? " Check your Tool's power and internet connection."
            : " Press the button on your Tool to sync immediatedly.")
        }
        oneButton={true}
        onPress={async () => {
          await getSettings(tool);
          setSyncPending(false);
        }}
      >
        {toolValue != undefined &&
        toolValue != null &&
        value != toolValue &&
        !usbPowered &&
        usbPowered != undefined ? (
          <View style={[Helpers.row, { marginTop: Spacing.sm }]} gutter="none">
            <View
              style={[
                styles.symbolContainer,
                { marginLeft: 0, marginRight: 0 },
              ]}
            >
              <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
            </View>
            <View>
              <Text color="lightGrey" as="small">
                {" Synchronization scheduled at " +
                  HelperService.formatTime(time, 0)}
              </Text>
            </View>
          </View>
        ) : (
          <></>
        )}
      </Alert>
    </View>
  );
};

Row.Slider = ({
  style,
  sliderStyle,
  icon,
  title,
  value,
  displayValue,
  minimumValue,
  maximumValue,
  step,
  onValueChange,
  onSlidingComplete,
  ...rest
}) => (
  <View
    style={[styles.row, styles.item, Metrics.smallBottomMargin, style]}
    padding="md"
    gutter="none"
  >
    {icon && (
      <View style={styles.itemIcon}>
        <Icon svg={icon} size="sm" />
      </View>
    )}
    <View style={styles.itemTitle}>
      <Text>{title}</Text>
    </View>
    <View style={styles.itemValue}>
      <Text as="small" color="dark">
        {displayValue ? displayValue : value}
      </Text>
    </View>
    <Slider
      style={sliderStyle}
      minimumValue={minimumValue}
      maximumValue={maximumValue}
      step={step}
      value={value}
      onValueChange={onValueChange}
      onSlidingComplete={onSlidingComplete}
      {...rest}
    />
  </View>
);

Row.Picker = ({
  style,
  icon,
  title,
  value,
  setValue,
  values,
  onPress,
  toolValue,
  syncTime,
  tool,
  getSettings,
  ...rest
}) => {
  // const dispatch = useDispatch()
  const [syncPending, setSyncPending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
    onPress(e.target.value);
    setShowModal(false);
  };
  let usbPowered =
    _.has(tool, "toolSystem") && !_.isEmpty(tool.toolSystem)
      ? tool.toolSystem.sysPowerState == "USB"
      : undefined;
  let time =
    tool && _.has(tool, "nextUpdateTS")
      ? new Date(tool.nextUpdateTS * 1000)
      : null;

  return (
    <View>
      <View
        style={[styles.lightRow, { flexDirection: "column" }, style]}
        gutter="none"
        sidePadding="md"
      >
        <View
          {...rest}
          style={[styles.item, { flex: 1, cursor: "pointer" }]}
          onClick={() => {
            console.log("OPEN MODAL!!!");
            setShowModal(true);
          }}
        >
          {icon && (
            <View style={styles.itemIcon}>
              <Icon svg={icon} size="xs" />
            </View>
          )}
          <View
            style={[
              styles.toolTitle,
              {
                justifyContent: "flex-start",
                alignItems: "center",
                overflow: "hidden",
                whiteSpace: "nowrap",
              },
            ]}
          >
            <Text as="medium" color="darkGrey">
              {title}
            </Text>
          </View>
          {onPress && (
            <View style={Helpers.center}>
              <View
                style={[
                  styles.rightText,
                  Helpers.row,
                  { alignItems: "center", justifyContent: "center" },
                ]}
              >
                {toolValue != undefined &&
                toolValue != null &&
                value != toolValue &&
                (syncTime || !usbPowered) &&
                usbPowered != undefined ? (
                  <View
                    style={[styles.itemIcon, { cursor: "pointer" }]}
                    onClick={() => {
                      setSyncPending(true);
                    }}
                  >
                    <Icon svg={syncPendingIcon} size="s18" />
                  </View>
                ) : (
                  <></>
                )}
                <Text
                  as="small"
                  style={{ paddingRight: 12 }}
                  color={"darkGrey"}
                >
                  {value}
                </Text>
                <Icon color={Colors.lightGrey} svg={arrowIcon} size="xs" />
              </View>
            </View>
          )}
        </View>
      </View>
      <Modal
        title={title}
        closeIcon={null}
        open={showModal}
        footer={null}
        onCancel={() => {
          setShowModal(false);
        }}
        onOk={() => {
          setShowModal(false);
        }}
        onClick={(event) => {
          event.stopPropagation();
          setShowModal(false);
        }}
      >
        <View
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Radio.Group onChange={onChange} value={value}>
            <Space direction="vertical">
              {values.map((item, index) => (
                <Radio value={item}>{item}</Radio>
              ))}
            </Space>
          </Radio.Group>
        </View>
      </Modal>
      <Alert
        visible={syncPending}
        setVisible={setSyncPending}
        title="Sync to Tool Pending"
        text={
          "Modified preferences have not been synced to your Tool." +
          (usbPowered
            ? " Check your Tool's power and internet connection."
            : " Press the button on your Tool to sync immediatedly.")
        }
        oneButton={true}
        onPress={async () => {
          await getSettings(tool);
          setSyncPending(false);
        }}
      >
        {toolValue != undefined &&
        toolValue != null &&
        value != toolValue &&
        !usbPowered &&
        usbPowered != undefined ? (
          <View style={[Helpers.row, { marginTop: Spacing.sm }]} gutter="none">
            <View
              style={[
                styles.symbolContainer,
                { marginLeft: 0, marginRight: 0 },
              ]}
            >
              <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
            </View>
            <View>
              <Text color="lightGrey" as="small">
                {" Synchronization scheduled at " +
                  HelperService.formatTime(time, 0)}
              </Text>
            </View>
          </View>
        ) : (
          <></>
        )}
      </Alert>
    </View>
  );
};
Row.Checkbox = (
  {
    style,
    icon,
    channelColor,
    title,
    value,
    label,
    onValueChange,
    noBorder,
    ...rest
  } // Helpers.fillRowCross
) => (
  <View
    {...rest}
    style={
      noBorder
        ? [styles.item, Helpers.column]
        : [styles.lightRow, styles.item, Helpers.column]
    }
    sidePadding="md"
  >
    <View style={[styles.item, style]} gutter="none">
      {/* <View {...rest} style={[ styles.item, style,{alignItems:'center'}]} sidePadding="md" gutter="none"> */}
      {icon && (
        <View style={styles.itemIcon}>
          <Icon color={channelColor} svg={icon} size="xs" />
        </View>
      )}
      <View
        style={[Helpers.fillRowCross]}
        onPress={() => {
          onValueChange(!value);
        }}
      >
        <View style={[styles.toolTitle, { flexDirection: "column" }]}>
          {/* <View style={{height: 32, alignItems:'center',...Helpers.row}}> */}
          {/* {channelColor && (<View style={{backgroundColor:channelColor, width:10, height:10, borderRadius:5, marginRight:5}}/>)} */}
          <Text style={{ width: "100%" }} as={"medium"} color={"darkGrey"}>
            {title}
          </Text>
          {/* </View> */}
          {label && (
            <Text as={"small"} color={"lightGrey"}>
              {label}
            </Text>
          )}
        </View>
        <Checkbox
          // tintColors={{ true: Colors.secondary, false: Colors.lightGrey }}
          // boxType="square"
          // tintColor={Colors.lightGrey}
          // onTintColor={Colors.secondary}
          // onFillColor={Colors.secondary}
          // onCheckColor={Colors.white}
          // disabled={false}
          checked={value}
          onChange={onValueChange}
          style={{
            width: 16,
            height: 16,
            paddingLeft: 0,
            marginRight: 8,
            marginVertical: 8,
          }}
        />
      </View>
    </View>
  </View>
);

Row.SenderShare = ({ style, children, share, token, onDelete, ...rest }) => {
  // const dispatch = useDispatch()
  let icon = userIcon;
  // const toolStatus = useSelector((state) => getStatus(state))
  const [open, setOpen] = useState(false);
  const [deleteShare, setDeleteShare] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [allowExport, setAllowExport] = useState(
    share.senderSettings.allowExport
  );
  const [allowSettings, setAllowSettings] = useState(
    share.senderSettings.allowSettings
  );
  const [allowAlert, setAllowAlert] = useState(share.senderSettings.allowAlert);
  const [allowClearData, setAllowClearData] = useState(
    share.senderSettings.allowClearData
  );

  // useEffect(() => {
  //   if(toolStatus.deleteShare.status != 'inProgress'){
  //     if(deleteShare) setDeleteLoading(false)
  //   }
  // }, [toolStatus]);

  useEffect(() => {
    const stopSharing = async () => {
      if (deleteLoading) {
        try {
          let response = await deleteShareAPI(token, share.share_id).then(
            (result) => result
          );
          setDeleteLoading(false);
          onDelete();
        } catch (error) {
          console.log("DELETE ERROR:", error);
        }
      } else {
        setDeleteShare(false);
      }
    };
    stopSharing();
  }, [deleteLoading]);

  let details = (
    <View
      style={{ ...styles.lightRow, ...Helpers.column, paddingLeft: 48 }}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <Row.Checkbox
        title="Export"
        icon={exportIcon}
        channelColor={Colors.lightGrey}
        value={allowExport}
        onValueChange={(newValue) => {
          setAllowExport(newValue.target.checked);
          updateSender(token, share.share_id, {
            allowExport: newValue.target.checked,
          });
        }}
      />
      <Row.Checkbox
        title="Alerts"
        icon={alertIcon}
        channelColor={Colors.lightGrey}
        value={allowAlert}
        onValueChange={(newValue) => {
          setAllowAlert(newValue.target.checked);
          updateSender(token, share.share_id, {
            allowAlert: newValue.target.checked,
          });
        }}
      />
      <Row.Checkbox
        title="Tool Settings"
        icon={prefIcon}
        channelColor={Colors.lightGrey}
        value={allowSettings}
        onValueChange={(newValue) => {
          setAllowSettings(newValue.target.checked);
          updateSender(token, share.share_id, {
            allowSettings: newValue.target.checked,
          });
        }}
      />
      <Row.Checkbox
        title="Clear Data"
        icon={clearIcon}
        channelColor={Colors.lightGrey}
        value={allowClearData}
        onValueChange={(newValue) => {
          setAllowClearData(newValue.target.checked);
          updateSender(token, share.share_id, {
            allowClearData: newValue.target.checked,
          });
        }}
      />
      <Row.SettingLink
        title="Delete Share"
        symbol={deleteIcon}
        color={Colors.lightGrey}
        onPress={() => {
          setDeleteShare(true);
        }}
      />
      {share.recipientSettings.acceptState == false ? (
        <Row.SettingLink
          title="Request not accepted"
          label="Resend"
          symbol={warningIcon}
          color={Colors.lightGrey}
          onPress={() => {}}
        />
      ) : (
        <></>
      )}
    </View>
  );

  const component = (
    <View style={[{ flexDirection: "column" }, style]}>
      <View
        {...rest}
        style={[styles.lightRow, styles.item, { flex: 1 }]}
        sidePadding="md"
        gutter="none"
      >
        <View style={styles.itemIcon}>
          <Icon color={Colors.lightGrey} svg={icon} size="xs" />
        </View>
        <View style={Helpers.fillRowCross}>
          <Text style={{ paddingRight: 10 }} as="medium" color="darkGrey">
            {share.senderSettings.recipientEmailID}
          </Text>
          {share.recipientSettings.acceptState == false ? (
            <Icon color={"#D2900F"} svg={warningIcon} size="xs" />
          ) : (
            <></>
          )}
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {open ? (
            <View
              style={{ ...Metrics.smallHorizontalMargin }}
              onClick={() => setOpen(false)}
            >
              <Icon color={Colors.lightGrey} svg={arrowDown} size="s10" />
            </View>
          ) : (
            <View
              style={{ ...Metrics.smallHorizontalMargin }}
              onClick={() => setOpen(true)}
            >
              <Icon color={Colors.lightGrey} svg={arrowUp} size="s10" />
            </View>
          )}
        </View>
        {children}
      </View>
      {open ? details : <></>}
    </View>
  );

  return (
    <View
      activeOpacity={1}
      onClick={() => {
        if (open) {
          setOpen(false);
        } else {
          setOpen(true);
        }
      }}
    >
      {component}
      <Alert
        visible={deleteShare}
        setVisible={setDeleteShare}
        title="Delete Share"
        text={
          "Are you sure you want to stop sharing this tool with " +
          share.senderSettings.recipientEmailID +
          "?"
        }
        loading={deleteLoading}
        onPress={() => {
          setDeleteLoading(true);
        }}
      />
    </View>
  );
};

Row.LinearScaling = ({
  style,
  ax,
  setAx,
  changeAx,
  bx,
  setBx,
  changeBx,
  ay,
  setAy,
  changeAy,
  by,
  setBy,
  changeBy,
  unit,
  setUnit,
  changeUnit,
  rawUnit,
  setPadding,
  axTool,
  axTime,
  changeAxTime,
  bxTool,
  bxTime,
  changeBxTime,
  ayTool,
  ayTime,
  changeAyTime,
  byTool,
  byTime,
  changeByTime,
  tool,
  getSettings,
  ...rest
}) => {
  // const dispatch = useDispatch()
  const [syncPending, setSyncPending] = useState(false);
  let usbPowered =
    _.has(tool, "toolSystem") && !_.isEmpty(tool.toolSystem)
      ? tool.toolSystem.sysPowerState == "USB"
      : undefined;
  let time =
    tool && _.has(tool, "nextUpdateTS")
      ? new Date(tool.nextUpdateTS * 1000)
      : null;
  var input1 = useRef();
  var input2 = useRef();
  var input3 = useRef();
  var input4 = useRef();
  var input5 = useRef();

  const component = (
    <View style={[styles.lightRow, Helpers.rowCross]}>
      <View style={{ flex: 1 }}>
        <View
          {...rest}
          style={[styles.lightRow, styles.item, { minHeight: Spacing.xxl }]}
          padding="sm"
          gutter="none"
          sidePadding="md"
        >
          <View style={styles.itemIcon}>
            <Icon svg={aIcon} size="s20" />
          </View>
          <View
            style={[Helpers.rowCross, Helpers.mainSpaceBetween, { flex: 1 }]}
          >
            <View style={[Helpers.rowCross, { paddingRight: Spacing.sm }]}>
              {axTool != undefined &&
              axTool != null &&
              ax != axTool &&
              (axTime || !usbPowered) &&
              usbPowered != undefined ? (
                <View
                  style={{ paddingRight: Spacing.sm }}
                  onClick={() => {
                    setSyncPending(true);
                  }}
                >
                  <Icon svg={syncPendingIcon} size="s18" />
                </View>
              ) : (
                <></>
              )}
              <Input
                ref={input1}
                autoCapitalize="none"
                style={{
                  minWidth: Spacing.xxxl,
                  backgroundColor: Colors.light,
                  textAlign: "center",
                  color: Colors.darkGrey,
                  padding: 2,
                  borderRadius: 5,
                  ...Fonts.medium,
                  fontFamily: "Inter-Regular",
                }} //medium
                selectionColor={Colors.highlight}
                value={ax}
                onChange={(event) => {
                  changeAxTime(false);
                  changeAx(event.target.value);
                }}
                keyboardType={"numeric"}
                onEndEditing={setAx}
                selectTextOnFocus={true}
                returnKeyType="done"
                // onFocus = {()=>checkFocus()}
                onBlur={setAx}
              />
              {rawUnit ? (
                <Text
                  style={{ alignSelf: "center" }}
                  as="medium"
                  color="darkGrey"
                >
                  {" " + rawUnit}
                </Text>
              ) : (
                <></>
              )}
            </View>
            <Icon svg={equalIcon} size="xs" />
            {ayTool != undefined &&
            ayTool != null &&
            ay != ayTool &&
            (ayTime || !usbPowered) &&
            usbPowered != undefined ? (
              <View
                style={{ paddingLeft: Spacing.sm }}
                onClick={() => {
                  setSyncPending(true);
                }}
              >
                <Icon svg={syncPendingIcon} size="s18" />
              </View>
            ) : (
              <></>
            )}
            <Input
              ref={input3}
              autoCapitalize="none"
              style={{
                minWidth: Spacing.xxxl,
                backgroundColor: Colors.light,
                textAlign: "center",
                color: Colors.darkGrey,
                padding: 2,
                borderRadius: 5,
                ...Fonts.medium,
                fontFamily: "Inter-Regular",
                marginLeft: Spacing.sm,
              }} //medium
              selectionColor={Colors.highlight}
              value={ay}
              onChange={(event) => {
                changeAyTime(false);
                changeAy(event.target.value);
              }}
              keyboardType={"numeric"}
              onEndEditing={setAy}
              selectTextOnFocus={true}
              returnKeyType="done"
              // onFocus = {()=>checkFocus()}
              onBlur={setAy}
            />
          </View>
        </View>
        <View
          {...rest}
          style={[styles.item, { minHeight: Spacing.xxl }]}
          padding="sm"
          gutter="none"
          sidePadding="md"
        >
          <View style={styles.itemIcon}>
            <Icon svg={bIcon} size="s20" />
          </View>
          <View
            style={[Helpers.rowCross, Helpers.mainSpaceBetween, { flex: 1 }]}
          >
            <View style={[Helpers.rowCross, { paddingRight: Spacing.sm }]}>
              {bxTool != undefined &&
              bxTool != null &&
              bx != bxTool &&
              (bxTime || !usbPowered) &&
              usbPowered != undefined ? (
                <View
                  style={{ paddingRight: Spacing.sm }}
                  onClick={() => {
                    setSyncPending(true);
                  }}
                >
                  <Icon svg={syncPendingIcon} size="s18" />
                </View>
              ) : (
                <></>
              )}
              <Input
                ref={input2}
                autoCapitalize="none"
                style={{
                  minWidth: Spacing.xxxl,
                  backgroundColor: Colors.light,
                  textAlign: "center",
                  color: Colors.darkGrey,
                  padding: 2,
                  borderRadius: 5,
                  ...Fonts.medium,
                  fontFamily: "Inter-Regular",
                }} //medium
                selectionColor={Colors.highlight}
                value={bx}
                onChange={(event) => {
                  changeBxTime(false);
                  changeBx(event.target.value);
                }}
                keyboardType={"numeric"}
                onEndEditing={setBx}
                selectTextOnFocus={true}
                returnKeyType="done"
                // onFocus = {()=>checkFocus()}
                onBlur={setBx}
              />
              {rawUnit ? (
                <Text
                  style={{ alignSelf: "center" }}
                  as="medium"
                  color="darkGrey"
                >
                  {" " + rawUnit}
                </Text>
              ) : (
                <></>
              )}
            </View>
            <Icon svg={equalIcon} size="xs" />
            {byTool != undefined &&
            byTool != null &&
            by != byTool &&
            (byTime || !usbPowered) &&
            usbPowered != undefined ? (
              <View
                style={{ paddingLeft: Spacing.sm }}
                onClick={() => {
                  setSyncPending(true);
                }}
              >
                <Icon svg={syncPendingIcon} size="s18" />
              </View>
            ) : (
              <></>
            )}
            <Input
              ref={input4}
              autoCapitalize="none"
              style={{
                minWidth: Spacing.xxxl,
                backgroundColor: Colors.light,
                textAlign: "center",
                color: Colors.darkGrey,
                padding: 2,
                borderRadius: 5,
                ...Fonts.medium,
                fontFamily: "Inter-Regular",
                marginLeft: Spacing.sm,
              }} //medium
              selectionColor={Colors.highlight}
              value={by}
              onChange={(event) => {
                changeByTime(false);
                changeBy(event.target.value);
              }}
              keyboardType={"numeric"}
              onEndEditing={setBy}
              selectTextOnFocus={true}
              returnKeyType="done"
              // onFocus = {()=>checkFocus()}
              onBlur={setBy}
            />
          </View>
        </View>
      </View>
      <View style={{ ...Helpers.rowCenter, minWidth: 100 }}>
        <Input
          ref={input5}
          autoCapitalize="none"
          style={{
            minWidth: Spacing.xxl,
            backgroundColor: Colors.light,
            textAlign: "center",
            color: Colors.darkGrey,
            padding: 2,
            borderRadius: 5,
            ...Fonts.medium,
            fontFamily: "Inter-Regular",
          }} //medium
          selectionColor={Colors.highlight}
          value={unit}
          onChange={(event) => changeUnit(event.target.value)}
          keyboardType={"default"}
          onEndEditing={setUnit}
          selectTextOnFocus={true}
          returnKeyType="done"
          maxLength={4}
          // onFocus = {()=>checkFocus()}
          onBlur={setUnit}
        />
      </View>
      <Alert
        visible={syncPending}
        setVisible={setSyncPending}
        title="Sync to Tool Pending"
        text={
          "Modified preferences have not been synced to your Tool." +
          (usbPowered
            ? " Check your Tool's power and internet connection."
            : " Press the button on your Tool to sync immediatedly.")
        }
        oneButton={true}
        onPress={async () => {
          await getSettings(tool);
          setSyncPending(false);
        }}
      >
        {(axTool != undefined &&
          axTool != null &&
          ax != axTool &&
          !usbPowered) ||
        (ayTool != undefined &&
          ayTool != null &&
          ay != ayTool &&
          !usbPowered) ||
        (bxTool != undefined &&
          bxTool != null &&
          bx != bxTool &&
          !usbPowered) ||
        (byTool != undefined &&
          byTool != null &&
          by != byTool &&
          !usbPowered) ? (
          <View style={[Helpers.row, { marginTop: Spacing.sm }]} gutter="none">
            <View
              style={[
                styles.symbolContainer,
                { marginLeft: 0, marginRight: 0 },
              ]}
            >
              <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
            </View>
            <View>
              <Text color="lightGrey" as="small">
                {" Synchronization scheduled at " +
                  HelperService.formatTime(time, 0)}
              </Text>
            </View>
          </View>
        ) : (
          <></>
        )}
      </Alert>
    </View>
  );

  return component;
};

export default Row;